(function() {
  "use strict";

  angular.module("sempraWebapp").constant("twTranslations", {
    MESSAGE:"訊息",
    ERROR_TITLE:"錯誤",
    ERROR_MESSAGE:"執行操作時發生錯誤。",
    ERROR_LOGIN:"登入時發生錯誤。(E-mail或密碼無效)",
    ERROR_LOGIN_ROLE:"目前應用品牌的身分無效。",
    OK:"好的",
    CANCEL:"取消",
    YES:"是",
    NO:"否",
    FROM:"從",
    TO:"到",
    DELETE:"刪除",
    SIGN_OUT:"登出",
    NAME:"姓名",
    DATE:"日期",
    PIECES:"件",
    HOURS:"小時",
    DAYS:"天",
    MONTH:"月",
    MONTHS:"個月",
    YEAR:"年",
    BOX:"箱子",
    SEARCH:"搜尋",
    ALL_USERS:"所有使用者",
    ARE_YOU_SURE:"您確定嗎?",
    BACK:"返回",
    AMOUNT:"數量",
    DESCRIPTION:"敘述",
    FORGOT_PASSWORD_ERROR_MSG:"發生錯誤，請檢查您的電子信箱並重試。",
    REQUIRED_FIELD:"必填欄位",
    LOGOUT_TITLE:"您確定要登出嗎?",
    LOGOUT_MSG:"您所有未儲存的資料都將遺失",
    ACTIVATION_ACCOUNT:"您已成功啟動您的帳戶",
    UNKNOWN_ERRROR_NOTIFICATION:"發生未知錯誤",
    CONTINUE:"繼續",
    DATA_NOT_AVAILABLE:"數據無法使用",
    SELECT:"選擇",
    SELECT_CURRENCY:"選擇貨幣",
    UPLOAD:"上傳",
    PHONE:"電話",
    WEBSITE:"網站",
    WORKING_HOURS:"工作時間",
    INSERT:"插入",
    TEXT:"文字",
    CREATED:"已創建",
    VALID_UNTIL:"有效期限至",
    SAVE:"儲存",
    TOKENS:"代幣",
    DELETE_COMPANY_HISTORY:"是否刪除公司歷史記錄？",
    DELETE_COMPANY_HISTORY_MESSAGE:"警告：按下此按鈕後，您的所有洗車交易記錄將永久刪除！該資料刪除後無法恢復。",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"您確定要永久刪除所有交易資料嗎?",
    HISTORY_SUCCESSFULY_DELETED:"歷史記錄成功刪除",
    HELP:"幫助",
    VALUE:"值",
    ACTIVATING_ACCOUNT_ERROR:"您的 R2W 帳戶啟動時出現問題，請重試。如果問題持續無法解決，請聯繫客服：support@ready2wash.com",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"歡迎來到Ca!sh 歐規高效自助洗車",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"歡迎來到R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"請輸入您的新密碼並確認以啟動 R2W 帳戶， 成功後您將被自動登入應用程式。",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"您可以稍後在應用程式中更改用戶設置",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:"Ca!sh 歐規高效自助洗車",
    RESET_PASSWORD_WELCOME_MSG:"R2W洗車",
    RESET_PASSWORD_WELCOME_MSG_2:"為了重置舊密碼，請輸入您的新密碼並確認，成功後您將被自動登入應用程式。",
    RESET_PASSWORD_WELCOME_MSG_3:"您可以稍後在應用程式中更改用戶設置",
    ENTER_NEW_PASSWORD:"輸入新密碼",
    REPEAT_NEW_PASSWORD:"請重複輸入新密碼",
    PASSWORD_MIN_LENGTH:"密碼長度必須至少為8個字元",
    PASSWORD_MAX_LENGHT:"密碼長度必須少於32個字元",
    PASSWORD_PATTERN:"密碼必須至少包含一個大寫字母和一個小寫字母",
    PASSWORD_MATCH:"密碼不匹配",
    ACTIVATE:"啟用",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"您已成功提交請求，請檢查您的電子郵件以獲取確認訊息。",
    VALIDATION_REQUIRED:"必填項目",
    VALIDATION_EMAIL:"無效的電子信箱地址",
    VALIDATION_INTEGER_NUMBER:"請輸入整數值",
    VALIDATION_HOURS_VALUE:"值必須介於 0-23 之間",
    VALIDATION_MINUTES_VALUE:"值必須介於 0-59 之間",
    VALIDATION_NOT_A_DATE:"值不是日期",
    VALIDATION_FROM:"起始日期晚於截止日期",
    VALIDATION_TO:"截止日期早於起始日期",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"該記錄已存在於資料庫中",
    PASSWORD_VALIDATION_PATTERN_NEW:"必須至少有一位數字、一個小寫字母和一個大寫字母，不允許有空格。",
    VALIDATION_PERCENT_VALUE:"值必須介於 1-999 之間",
    NUMBERS_ONLY_100:"計數最多到 100 ",
    NUMBERS_ONLY_1000:"計數最多到 1000",
    POSITIVE_NUMBERS_ONLY:"只計算數位",
    GRID_PAGER_PAGE:"頁",
    GRID_PAGER_ROWS_PER_PAGE:"每頁行數",
    GRID_PAGER_PAGE_OF:"的",
    BREAD_CRUMBS_HOME:"家",
    BREAD_CRUMBS_DASHBOARD_TECH:"儀表板技術",
    BREAD_CRUMBS_DETAILS:"細節",
    BREAD_CRUMBS_SETTINGS:"設定",
    BREAD_CRUMBS_WORKING_HOURS:"工作時間",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"天數總金額報告",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"每小時平均金額報告",
    BREAD_CRUMBS_NEW_USER_GROUP:"建立使用者群組",
    BREAD_CRUMBS_EDIT_USER_GROUP:"編輯使用者群組",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"建立活動模板",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"編輯活動模板",
    BREAD_CRUMBS_NEW_CAMPAIGN:"創建活動",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"編輯活動",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"定期總結",
    LOGIN:"登入",
    EMAIL:"電子信箱",
    PASSWORD:"密碼",
    LANGUAGE:"語言",
    FORGOT_PASSWORD:"忘記密碼?",
    SUBMIT:"提交",
    HEADER_NUMBER_OF_PENDING_ALARMS:"待處理警報數量：",
    HEADER_VIEW_ALL_ALARMS:"查看所有警報...",
    HEADER_MY_ACCOUNT:"我的帳戶",
    HEADER_ACCOUNT_MANAGEMENT:"帳戶管理",
    ACCOUNT_ALREADY_EXIST:"電子郵件地址已被使用",
    NEWSLETTER_CONFIRMATION:"發送警報狀態的​​電子郵件通知",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"每日財務概覽",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"儀表板技術",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"儀表板",
    ASIDE_MENU_ALARMS:"訊息",
    ASIDE_MENU_FACILITIES:"設施",
    ASIDE_MENU_REPORTS:"報告",
    ASIDE_MENU_REPORT:"選擇報告",
    ASIDE_MENU_LOYALTY:"忠誠",
    ASIDE_MENU_USER_GROUPS:"使用者群組",
    ASIDE_MENU_PERIODIC_SUMMARY:"定期總結",
    ASIDE_MENU_MANAGING_TOKENS:"管理代幣",
    ASIDE_MENU_NEWS:"消息",
    DAILY_FINANCES_TOTAL_MONEY:"總金額",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"所有設施的總金額",
    DAILY_FINANCES_TOTAL_COINS:"金屬代幣使用總數",
    DAILY_FINANCES_DOWNLOAD_CSV:"下載CSV",
    DAILY_FINANCES_ONLINE:"R2W(線上)",
    DAILY_FINANCES_OFFLINE:"現金",
    DAILY_FINANCES_CHANGER:"兌幣機現金",
    DAILY_FINANCES_COINS:"代幣/Eurokey",
    REPORTS_FILTER:"篩選",
    REPORTS_TYPE_OF_REPORT:"報告類型",
    REPORTS_CHOOSE_FACILITY:"選擇設施",
    REPORTS_PERIOD_1:"期間 1-",
    REPORTS_PERIOD_2:"期間 2-",
    MONEY_BY_DATE_REPORT:"按日期劃分的總收入",
    R2W_BY_DATE_REPORT:"按日期劃分的 R2W 代幣總收入",
    COINS_BY_DATE_REPORT:"按日期使用的代幣總數",
    AVG_MONEY_BY_HOUR_REPORT:"每小時平均收入",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"按星期幾的平均收入",
    AVG_MONEY_BY_BOX_REPORT:"依車格劃分的開支",
    COMPARE_PERIODS_REPORT:"設施比較報告",
    TOTAL_USERS_BY_GROUP:"每日 R2W app 總訪問量",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"使用者",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"訪問",
    VISITS_COUNT_REPORT:"每次造訪的 R2W app用戶數",
    LOYALTY_PER_DAY_REPORT:"每天花費的本地代幣數量",
    LOYALTY_PER_PAYMENT_METHOD:"每種支付方式給定的本地代幣",
    VISITS:"訪問",
    VISIT:"訪問",
    TOTAL_SPENT_MONEY:"總收入",
    MONEY:"錢",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"期間總收入金額",
    DOWNLOAD_CSV:"下載CSV",
    TOTAL_SPENT_COINS:"花費的代幣總計",
    TOTAL_USERS:"用戶總計",
    TOTAL_CREDIT_GIVEN:"本地虛擬代幣花費總額",
    EUROKEY_BY_DATE_REPORT:"按日期劃分的 Eurokey 付款總額",
    TOTAL_SPENT_EUROKEY:"總支出",
    SELECT_TYPE_OF_REPORT:"您需要選擇報告類型",
    NUMBER_OF_VISITS_TITLE:"訪問次數",
    NUMBER_OF_USERS_TITLE:"使用者數量",
    PIECES_TITLE:"件",
    TOTAL_VISITS:"總訪問量",
    TOKENS_TITLE:"代幣",
    SEARCH_USERS_NO_RESULTS:"未找到針對給定搜尋字詞的用戶",
    SEARCH_USERS:"搜尋用戶",
    SEARCH_TELEPHONES:"透過手機號碼搜尋用戶",
    ADD_USER_TO_GROUP:"將使用者新增至群組",
    REMOVE_USER_FROM_GROUP:"從群組中刪除用戶",
    USER_GROUP_NAME_REQUIRED:"使用者群組名稱為必填項",
    USER_GROUP_NAME:"使用者群組名",
    USER_GROUPS_OVERVIEW:"使用者群組概覽",
    USER_COUNT:"使用者數",
    NEW_USER_GROUP:"建立新使用者群組",
    DELETE_USER_GROUP:"刪除使用者群組",
    UPDATE_USER_GROUP:"編輯使用者群組",
    DELETE_USER_GROUP_ERROR:"刪除所選用戶群組時發生錯誤，請重試或聯絡支援人員...",
    CONFIRM_DELETE_USER_GROUP:"您確定要刪除選定的使用者群組嗎？",
    CONFIRM_DELETE_USER_GROUP_TEXT:"已刪除的群組所指派到的忠誠度操作將不再適用。",
    GROUP_NAME_MAX_LENGTH:" 群組名稱長度必須少於 255 個字",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:" 用戶已在該群組中",
    MISSING_USER:" 缺少使用者",
    USER_NOT_ON_LIST:" 使用者不在有效使用者清單中，檢查電子郵件地址是否有效，然後再試一次。",
    UPLOAD_USER_GROUP:"從 *.csv 檔案上傳使用者群組列表",
    UKNOWN_USERS:"未知使用者列表",
    CAMPAIGN_TEMPLATE_RULE:"活動範本規則",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:" 嘗試刪除行銷活動範本時發生錯誤，請重試或聯絡支援人員..",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:" 您確定要刪除選定的行銷活動範本嗎",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"您確定要刪除選定的行銷活動範本嗎",
    CAMPAIGN_TEMPLATES_OVERVIEW:" 行銷活動範本概觀",
    DELETE_CAMPAIGN_TEMPLATE:" 刪除活動範本",
    UPDATE_CAMPAIGN_TEMPLATE:" 編輯活動範本",
    CREATE_CAMPAIGN_TEMPLATE:" 建立新的活動範本",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:" 活動範本名稱為必填項",
    CAMPAIGN_TEMPLATE_NAME:" 活動範本名稱",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:" 必填項目",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"提供 %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"額外的時間",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"請先選擇類型，清洗車格或小型機器。",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:" 刪除範本規則",
    CAMPAIGN_TEMPLATE_RULE_FROM:"從",
    CAMPAIGN_TEMPLATE_RULE_TO:"到",
    CAMPAIGN_TEMPLATE_RULE_HOURS:" 小時",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"分鐘",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"按造訪次數的新規則",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"按花費代幣數量的新規則",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"按星期幾的新規範",
    CAMPAIGN_TEMPLATE_ADD_RULE:" 新增範本規則",
    CAMPAIGN_TEMPLATE_RULE_1:"每一個",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"每一個",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:" 花費的代幣少於",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:" 訪問時間少於",
    CAMPAIGN_TEMPLATE_RULE_3:" 天",
    CAMPAIGN_TEMPLATE_RULE_4:" 代幣",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:" 規則清單是空的",
    CAMPAIGN_FROM_DATE_TOO_EARLY:" 日期不能是過去的日期",
    DELETE_CAMPAIGN_ERROR:" 嘗試刪除活動時發生錯誤，請重試或聯絡支援人員...",
    CONFIRM_DELETE_CAMPAIGN:" 您確定要刪除選定的活動嗎？",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"R2W 對由此操作引起的使用者體驗不負責。",
    CAMPAIGNS_OVERVIEW:" 活動概覽",
    DELETE_CAMPAIGN:"刪除活動",
    UPDATE_CAMPAIGN:" 編輯活動",
    CREATE_CAMPAIGN:" 建立新的活動",
    CAMPAIGN_ACTIVE:"活躍的",
    CAMPAIGN_TEMPLATE:" 範本",
    CAMPAIGN_GROUPS:" 團體",
    CAMPAIGN_ALL_USERS:" 全部用戶",
    CAMPAIGN_NAME:" 活動名稱",
    CAMPAIGN_NAME_REQUIRED:"必填",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"每日接近門檻的使用者數",
    MESSAGE_TO_USERS:"給已過濾用戶的訊息",
    SEND_MESSAGE:"發送訊息",
    THRESHOLD:"門檻",
    TYPE:" 類型",
    TOTAL_MONEY_SPENT:" 活動花費的總資金",
    NUMBER_OF_VISITS:" 活動中的訪問次數",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:" 訊息長度必須至少 10 個字元",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:" 訊息長度必須少於 350 個字元",
    SEND_MESSAGE_REQUIRED_VALIDATION:"留言內容為必填項",
    TECHNOLOGY:"科技",
    TAP_WATER:"自來水",
    REVERSE_OSMOSIS:"逆滲透",
    SOFTENED_WATER:"軟化水",
    DOSER:"計量器",
    STATUS:"狀態",
    LAST_SYNCHRONIZATION:"最後同步",
    NO_OF_CURRENT_ALARMS:"目前警報數量",
    NO_OF_CURRENT_WARNINGS:"目前警告數量",
    WEATHER:" 天氣",
    BOXES_WORK_HOURS_COUNTERS:"洗車格工作時間",
    BOX_TOTAL_HOURS:" 總工作時間",
    BOX_SERVICE_HOURS:" 總工作時間（服務）",
    BOX_COUNTER_HOURS:"小時",
    ALARMS_AND_WARNINGS:" 警報和警告",
    FILTER_AND_BOILER:"過濾器和鍋爐",
    FILTER_TOTAL_DAYS:"濾心工作天數",
    BOILER_TOTAL_DAYS:"鍋爐工作天數",
    DAYS_UNIT:" 天",
    SOFTENER:" 柔軟劑",
    MANUAL_COLD_DRAIN:"手動冷排水",
    EL_COLD:"El. cold",
    DRAIN:"排水",
    TAP:"輕敲",
    WASTE:"耗費",
    OSMOSIS:" 滲透",
    DEMI_WATER:"去離子水",
    EL_RINSE:"El. m. rinse",
    BOILER:" 鍋爐",
    EL_WAX:"El. m. wax",
    FLOOR_HEATING:"地暖",
    DOSER_TANK:"計量罐",
    EL_WASH:"El. m. wash",
    DETERGENT:" 洗劑",
    VIBRATOR:" 振動器",
    UPDATE_FACILITY_SETTINGS:" 更新設定",
    GENERAL_SETTINGS:" 一般設定",
    LIGHTS:"燈",
    GROUPS:" 群組",
    ANTI_FREEZE:"防凍",
    AUTO:"自動",
    MANUAL:" 手動的",
    ON:"開",
    OFF:" 關",
    TEMPERATURE:" 溫度",
    UPDATE_DEVICE:" 更新設施設定",
    BOX_CLEAN_HOURS:"洗車格清洗計數器(小時)",
    GROUP_COUNTERS:"群組計數器",
    RESET:" 重置",
    CASH_COUNT:" 硬幣計數",
    COINS_COUNT:" 代幣計數",
    EUROKEY_COUNT:" Eurokey計數",
    DOSER_WORK:" 計量器工作時間（秒）",
    DOSER_PAUSE:" 計量器暫停時間（秒）",
    DELAY_BFV:"BFV 延遲（毫秒）",
    DELAY_6M1:"6M1 延遲（毫秒）",
    DELAY_LPS:"LPS 延遲（毫秒）",
    RESET_CASH_COUNT_ALL:" 重置所有硬幣計數器",
    RESET_COINS_COUNT_ALL:" 重置所有代幣計數器",
    RESET_EUROKEY_COUNT_ALL:" 重置所有 Eurokey 計數器",
    FACILITY_DETAILS:" 設施詳情",
    FACILITY_NAME:" 設施名稱",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:" 您已成功上傳圖片",
    FACILITY_UPDATE_DATA_NOTIFICATION:" 您已成功更新數據",
    CONNECTED:" 已連接",
    DISCONNECTED:" 已斷線",
    OFFLINE:" 離線",
    MESSAGES_FILTER:" 訊息過濾器",
    FACILITY:" 設施",
    APPLY:" 申請",
    TIME:" 時間",
    LOCATION:"地點",
    ACKNOWLEDGED:" 已確認",
    FILTERED_MESSAGES:" 過濾的訊息",
    ACK:" 已確認",
    NOT_ACK:"未確認",
    ALL:" 全部",
    ALL_FACILITIES:"所有設施",
    ENTER_DATE_PLACEHOLDER:" 輸入日期",
    OP_NESTANAK_NAPONA:"相位指示器 3A5 缺乏電壓",
    OP_OTB_PUMPA_GRESKA_MZS:" 高壓幫浦斷路器斷線",
    OP_UPR_NAPON_24VAC_GRE:"缺少 24 VAC - 斷路器 5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"乾淨水箱已空",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"主要水幫浦斷路器斷線",
    OP_MIN_NIVO_OMEKS_VODE:"軟化水箱已空",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:" 軟水幫浦斷路器斷線",
    OP_MIN_NIVO_DEMIN_VODE:"滲透水箱已空",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"滲透水幫浦斷路器斷線",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"滲透生產幫浦斷路器斷線",
    OP_BOJLER_GRESKA_MZS:"熱水器故障",
    OP_CRPKA_PRASKA_GRE_MZS:"熱水幫浦斷路器斷線",
    OP_DOZATOR_PRASKA_GRE_MZS:"粉末計量馬達斷路器斷線",
    OP_VIBRATOR_PRASKA_GRE_MZS:"粉末計量振動器斷路器斷線",
    OP_MIN_PRASAK_TON_ALARM:"粉末混合箱已空",
    OP_USIS_KOV_TURBINA_GRESKA:"硬幣真空渦輪斷路器斷線",
    OP_FILTER_VODE_ZACEPLJEN:"水過濾器堵塞",
    OP_VISKTL_RESET_SATI_RADA:"高壓幫浦服務",
    OPW_VISKTL_RESET_SATI_RADA:"高壓幫浦服務",
    OP_FILTER_DANI_RADA:"水過濾器故障",
    OP_BOJLER_DANI_RADA:"熱水器故障",
    OPW_ALARM_VISOKOTL_PUMPA:"高壓幫浦警報",
    OPW_ALARM_FILTER_SERVIS:" 過濾器服務警報",
    OPW_ALARM_BOJLER_SERVIS:" 鍋爐服務警報",
    HAS_MEMBERS:" 所選群組已有成員且無法刪除，請先刪除成員。",
    PERIODIC_SUMMARY_FOR:" 定期總結報告",
    PERIODIC_SUMMARY_REPORTS:"定期總結報告",
    DATE_RANGE:"日期範圍",
    FINANCIAL_REPORT:" 財務報告",
    GROSS_INCOME:"總收益",
    GROSS_INCOME_SUM:"總收益總和",
    COMMISSION_FEE:" 佣金費用",
    NET_INCOME:" 淨收入(用於計費)",
    COMMISSION_FEE_DETAILS:"佣金費用包括銀行/PayPal 條款或簡訊服務提供者費用。",
    LOYALTY_CREDITS_REPORT:"本地代幣報告",
    LOYALTY_GIVEN:"贈送的本地代幣",
    LOYALTY_USED:" 使用的本地代幣",
    LOYALTY_SOLD:"本地代幣已載入",
    LOYALTY_TOTAL:"總計",
    LOYALTY_CURRENT_MONTH:"本月",
    SOMETHING_WENT_WRONG:" 出了點問題",
    MISSING_PAGE:" 對不起，我們找不到該頁面。",
    TRY_AGAIN:" 請再試一次",
    DEFAULT_ERROR_NAME:" 發生未知錯誤",
    DEFAULT_ERROR_DESCRIPTION:" 請再試一次",
    MY_ACCOUNT_DETAILS:" 我的帳戶詳細細節",
    SAVE_CHANGES:" 儲存變更",
    USERNAME:" 使用者名稱",
    FIRST_NAME:" 名",
    LAST_NAME:" 姓",
    USER_ROLE:"用戶角色",
    OLD_PASSWORD:" 舊密碼",
    NEW_PASSWORD:" 新密碼",
    OLD_PASSWORD_REQUIRED:"需要舊密碼",
    NEW_PASSWORD_REQUIRED:"需要新密碼",
    NEW_PASSWORD_REPEAT:"需要重複輸入新密碼",
    NEW_PASSWORD_NOT_MATCH:" 新舊密碼不符",
    PASSWORD_DIFFERENT_VALIDATION:" 新密碼必須與舊密碼不同",
    PASSWORD_MIN_CHAR:" 密碼長度必須至少 8 個字元",
    PASSWORD_MAX_CHAR:"密碼長度不得超過 32 個字元",
    PASSWORD_PATTERN_VALIDATION:" 密碼必須至少包含一個數字",
    ACCOUNT_MANAGEMENT:" 帳號管理",
    NOT_ACTIVE:"不活躍",
    ASSIGN_ROLE:" 分配角色",
    UPDATE:" 更新",
    ADD_NEW_ACCOUNT:" 新增帳戶",
    EMAIL_REQUIRED:" 電子郵件地址為必填項",
    EMAIL_NOT_VALID:"電子郵件地址無效",
    ADD_NEW_USER_TEXT:" 啟用連結將發送到提供的電子郵件地址",
    UPDATE_USER_NOTIFICATION:" 您已成功更新您的資訊",
    CHANGED_PASSWORD_NOTIFICATION:" 您已成功更改密碼",
    UPDATE_USER_GROUP_NOTIFICATION:" 您已成功更新使用者群組名稱",
    CREATE_USER_GROUP_NOTIFICATION:"您已成功建立群組",
    DETELE_USER_GROUP_NOTIFICATION:" 您已成功刪除群組",
    EMPTY_GROUP_LIST_MSG:"沒有已建立的群組，開始建立一個。",
    DELETE_USER_FROM_GROUP_NOTIFICATION:" 您已成功從群組中刪除使用者",
    ADD_USER_TO_GROUP_NOTIFICATION:"您已成功將使用者新增至群組中",
    ADD_USER_NOTIFICATION:" 您已成功新增使用者",
    DELETE_USER_NOTIFICATION:" 您已成功刪除使用者",
    RESEND_USER_VERIFICATION_EMAIL:" 您已成功重新傳送驗證電子郵件",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:" 為了創建一個使用者群組",
    DELETE_USER:" 刪除使用者",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"您確定要從使用者群組中刪除使用者嗎？",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:" 尊敬的R2W用戶",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"依造訪次數的忠誠度規則",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"依花費代幣金額的忠誠度規則",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"依每週幾的忠誠度規則",
    REMOVE_CAMPAIGN_RULE_TITLE:"活動規則刪除",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"您確定要刪除活動規則嗎？",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:" 您已成功建立新的活動",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"您已成功啟動活動",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"沒有已建立的活動，開始建立一個。",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:" 您已成功發送訊息",
    COMPANY_ACCOUNTS:" 公司帳戶",
    BUSSINESS_INVOICES_LIST:" 我的 B2B 發票",
    LOCALE_TOKEN:" 本地代幣",
    R2W:"全球代幣",
    START_MONTH:"起始月份",
    END_MONTH:" 結束月份",
    TOKEN_TYPE:" 代幣類型",
    TOKEN_NUMBER:" 代幣數量",
    NOTHING_TO_DISPLAY:"* 無內容顯示",
    CREATE_INVOICE:" 建立發票",
    INVOICE:" 發票",
    INVOICES:" 發票",
    EDIT_INVOICE:" 編輯發票",
    UPDATE_INVOICE_NOTIFICATION:" 您已成功將發票更新為待處理狀態",
    CURRENT_CHARGES:" 當期費用",
    PAYMENTS_ON_HOLD:"處理中的發票",
    FOR_INVOICING:"用於開立發票",
    CANCEL_INVOICING_NOTIFICATION_HEADER:" 您即將取消發票",
    CANCEL_INVOICING_NOTIFICATION_TEXT:" 您確定要取消此發票嗎？",
    INVOICING_NOTIFICATION_HEADER:"您即將進行發票處理",
    INVOICING_NOTIFICATION_TEXT:"您確定要寄送發票嗎？",
    SENT_INVOICE_NOTIFICATION:"您已成功發送發票",
    CANCELED_INVOICE_NOTIFICATION:"您已成功取消發票",
    INVOICE_DESCRIPTION_TEXT:" 發票給予",
    INVOICE_STATE:" 發票狀態",
    INVOICE_NUMBER:" 發票號碼",
    INVOICE_TOTAL:"總計",
    SELECT_YEAR:" 選擇年份",
    DOWNLOAD:"下載PDF",
    INVOICE_NUMBER_HEADER:"您即將寄送編號的發票",
    INVOICE_PAYMENT_CONFIRMATION:"您即將確認付款",
    INSERT_INVOICE_NUMBER:"鍵入發票號碼",
    INVOICED_WARNING:"電子郵件未傳送，請稍後...",
    SEND_INVOICE:"傳送",
    INVOICE_ALL:" 全部",
    INVOICE_FROM_R2W:"來自 R2W",
    INVOICE_TO_R2W:" 至 R2W",
    PAYMENT_REQUEST:" 付款請求",
    PAYMENT_REQUEST_STATE:" 付款請求狀態",
    PAYMENT_REQUEST_NUMBER:" 付款請求編號",
    FOR_PAYMENT_REQUEST:"對於付款請求",
    PAYMENT_REQUEST_ON_HOLD:" 付款請求正在處理中",
    DOWNLOAD_INVOICE:" 下載發票",
    CLICK_FOR_DOWNLOAD_OPTIONS:"點擊以獲取下載選項",
    B2B_SPEC:" B2B規範",
    B2C_SPEC:" B2C規範",
    DOWNLOAD_PAYMENT_REQUEST:" 下載付款請求",
    LOYALTY_PREVIEW:" 忠誠度預覽",
    ACTIVATED:"啟動的",
    RUNNING:"運行",
    NOT_ACTIVATED:" 未啟用的",
    FINISHED:" 完成的",
    DEPRECATED:" 已棄用",
    UPCOMING:" 即將推出",
    NONE:" 個人",
    STARTED:" 已開始",
    ENDS:" 結束",
    DEDICATED:" 致力於",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:" 您即將啟動",
    CAMPAIGN:"活動",
    SEND_MESSAGE_NOTIFICATION:" 您即將向選定的用戶群組發送訊息",
    DIVISIBLE_TO_NUMBER:" 該數字應該可以整除",
    BRIDGE_PLC:"電橋 - PLC",
    DEVICE_TYPE:" 設備類型",
    LISTENER:" 小型機器",
    BRIDGE:"洗車格",
    WASH_BOXES:"洗車格",
    VACUUMS:" 吸塵器",
    SAVE_NEWS:"儲存消息",
    CREATE_NEW_NEWS:"建立新消息",
    HISTORY_OF_ALL_NEWS:"所有歷史消息",
    TYPE_FACILITY_NAME_PLACEHOLDER:"鍵入設施名稱",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:" 增加另一個設施",
    NEWS_TEXT:"消息內文",
    NEWS_TITLE:"消息標題",
    DELETE_NEWS_CONFIRMATION:"您即將刪除消息",
    NEWS_DELETE_NOTIFICATION:"您已成功刪除消息",
    NEWS_SAVE_NOTIFICATION:"您已成功儲存消息",
    NEWS_CREATION_DATE:"建立日期",
    NO_TITLE:"無標題",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"消息內文必須少於255個字元",
    NEWS_TEXT_REQUIRED_VALIDATION:"消息文字為必填項",
    NEWS_TITLE_REQUIRED_VALIDATION:"消息標題為必填項",
    DEACTIVATE:" 停用",
    ASIDE_MENU_LOCAL_TOKENS:" 本地代幣",
    CREATE_NEW_LOCAL_TOKENS:" 發出新的本地代幣",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:" 輸入客戶電子郵件以及您想要發出給客戶的本地代幣數量",
    CREATE_TOKENS:" 發出代幣",
    MINIMUM_ONE_TOKEN:"值必須是大於 0 的數字",
    CUSTOMER_EMAIL:"客戶電子郵件",
    AMOUNT_OF_TOKENS:"代幣數量",
    ISSUING_LOCAL_TOKENS_SUCCESS:" 成功發行本地代幣",
    PROBLEM_ISSUING_LOCAL_TOKENS:"發行本地代幣時發生錯誤，請檢查客戶電子郵件地址並重試。",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"已發出本地代幣概覽",
    ISSUED_AT:"發出於",
    ISSUED_BY:"發出者",
    CODE:" 兌換代碼",
    REDEEMED_BY:" 兌換者",
    REDEEMED_AT:" 兌換於",
    ASIDE_MENU_VOUCHERS:" 優惠券",
    PRINT:" 列印",
    VOUCHERS_OVERVIEW:" 優惠券概覽",
    CREATE_NEW_VOUCHERS:" 建立新優惠券",
    CREATE_NEW_VOUCHERS_DESCRIPTION:" 透過輸入每張優惠券的代幣數量以建立新的可兌換優惠券批次",
    AMOUNT_OF_TOKENS_PER_VOUCHER:" 每張優惠券的代幣數量",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"您可以為每張優惠券分配 1 到 100 個代幣",
    NUMBER_OF_NEW_VOUCHERS:" 待建立的優惠券數量",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"您可以在一個批次中建立 1 到 {{size}} 個優惠券",
    NEW_VOUCHERS_PREFIX:"新優惠券系列代碼字首",
    VALIDATION_VOUCHER_PREFIX:"代碼字首必須正好是 4 個字元（大寫字母和/或數字）",
    PROBLEM_CREATING_NEW_VOUCHERS:" 建立新優惠券時出現問題，請重試或聯絡我們的客服人員。",
    CREATE_VOUCHERS:"建立優惠券",
    CREATING_VOUCHERS_SUCCESS:" 新優惠券建立成功",
    PRINT_NEW_VOUCHERS:" 列印優惠券",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"輸入優惠券系列代碼字首以列印整個優惠券系列。或者",
    PRINT_VOUCHERS_PREFIX:" 優惠券（系列）代碼字首",
    NO_VOUCHERS_FOR_PRINT:" 找不到與提供的代碼字首相符的優惠券可供列印",
    PRINT_VOUCHERS:" 列印優惠券",
    VALIDATION_VOUCHER_CODE_FILTER:" 優惠券搜尋字詞必須由大寫字母和數字組成",
    FILTER_VOUCHERS_BY_CODE:" 透過兌換碼搜尋優惠券",
    FILTER_VOUCHERS:"搜尋優惠券",
    WASH_BOX:"洗車格",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"數位代幣使用總數",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:" 按日期列出的本地代幣銷售總量",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:" 按日期列出的本地代幣總支出",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:" 按日期列出的總給出本地代幣數量",
    LOCAL_TOKEN:"本地代幣",
    GIVEN_TOKEN:"給出的本地代幣",
    SOLD_TOKEN:" 售出的本地代幣",
    SMALL_MACHINES:" 小型機器",
    R2W_Listener:"監聽器",
    HHANLE_DEVICE:"HHanle wash box",
    CODE_PREFIX_EXIST:" 程式碼字首已存在",
    CODE_PREFIX_EXIST_TEXT:" 您無法使用此代碼字首建立新優惠券，請再設定一個。",
    MIN_FOUR_VALIDATION:" 正好 4 個字元",
    ALL_INFORMATION_1:"所有資訊關於",
    ALL_INFORMATION_2:"將遺失",
    ASIDE_MENU_TRANSACTIONS:" 交易",
    EXPENSES:" 花費",
    TOPUPS:"儲值",
    EXPENSES_LIST:" 費用清單",
    USER_EMAIL:" 使用者電子郵件",
    COMPANY_NAME:" 公司名稱",
    TOPUPS_LIST:" 儲值清單",
    CONSUMER:" 消費者",
    SYSTEM_ADMIN:" 系統管理員",
    MERCHANT_ADMIN:" 商家管理員",
    COMPANY_ADMIN:" 公司管理員",
    FACILITY_ADMIN:" 設施管理員",
    SUBSCRIBER:"訂閱戶",
    CONFIGURATOR:"配置器",
    SETUP_UNIT_SERIAL_NO:" 序號",
    SETUP_UNIT_MATERIAL_NO:" 物料號碼",
    SETUP_UNIT_WEBAPI_VERSION:" WebApi 版本",
    TOTAL_TURNOVER:"洗車設施營業額",
    AVAILABILITY_ALL:" 可用性",
    AVAILIBILITY:"洗車格可用性",
    AVAILABILITY_VACUUMS:"吸塵器可用性",
    WASH_BOX_INFO:"洗車格資訊",
    VACUUM_CLEANER_INFO:"吸塵器資訊",
    BREAD_CRUMBS_SERVICE:" 服務",
    HOLIDAYS:"假日",
    HOLIDAY:"假日",
    LIGHTS_ON:" 開燈",
    LIGHTS_OFF:" 關燈",
    WASH_BOXES_ON:"洗車格開啟",
    WASH_BOXES_OFF:"洗車格關閉",
    VACUUMS_ON:" 吸塵器開啟",
    VACUUMS_OFF:" 吸塵器關閉",
    TURNOVER:"營業額",
    TURNOVER_MANUAL_WASH_UNIT:"營業額手冊",
    STATUS_BAY_RUN_TIME:"洗車格工作時間總計",
    STATUS_BAY_PROGRAM_NAME:"程式名稱",
    STATUS_BAY_CREDIT:"洗車格信用/餘額",
    CLOUD_KREDIT:"雲端信用",
    STATUS_VACUUM_RUN_TIME:"吸塵器工作時間總計",
    SHOW_SERVICE_AND_PROGRAM_INFO:"設施服務、洗車格程序和當前故障資料訊息",
    UNAVAILABLE:" 單位不可用",
    SHOW_HIDE_TABLE:" 顯示/隱藏工作時間表",
    PROGRAM_NAME:"程式名稱",
    PROGRAM_OPTION:"程式選項",
    DEVICE:"設備",
    QUANTITY:"數量",
    PROGRAM_COUNTER:"程式計數器",
    NO_NAME:" 參考資訊沒有名稱",
    COUNTER_SERVICE_DATA:"服務數據",
    NEED_SERVICE:"服務需求",
    PROGRAM_DATA:"洗車格程式數據",
    CURRENT_FAULT_DATA:"當前故障數據",
    REFERENCE_DUE:" 到期的",
    REFERENCE_SECONDS:" 秒數",
    REFERENCE_NAME:" 零件名稱",
    WASHBOX_NAME:"洗車格名稱",
    FAULT_NAME:" 故障名稱",
    FAULT_NUMBER:" 故障號碼",
    CURRENT_FAULT_COUNT:"目前故障",
    DEVICE_NOT_INSTALLED:" 裝置未安裝",
    STATUS_READY:"就緒狀態",
    STATUS_ERROR:"錯誤狀態",
    CONNECTION_ERROR:" 離線",
    UNKNOWN_RESET:" 軟體錯誤",
    SOFTWARE_RESET:" 軟體錯誤",
    EXTERNAL_PIN_RESET:" 軟體錯誤",
    RESTART_OR_BROWNOUT_OCCURRED:" 軟體錯誤",
    DEAD_RM5_CHANNEL_PIN_ERROR:"硬體錯誤",
    COULD_NOT_SIMULATE_COIN:"硬體錯誤",
    ERROR_SETTING_INHIBIT_MODE:"硬體錯誤",
    OFFLINE_DEVICE:"洗車廠離線",
    TARIFFS:"關稅",
    DAY:" 天/日",
    NIGHT:"晚上",
    VOUCHER_CODE:" 優惠券代碼",
    DISMISS_ALARM:" 重置鬧鐘？",
    ALARM_ACTIVE:"當前未解除警報",
    NO_ALARM_ACTIVE:"沒有未解除警報",
    ALARM_HISTORY:" 警報歷史記錄",
    MANAGING_TOKENS:" 管理代幣",
    EXPIRATION_DATE:" 截止日期",
    EXTEND_TOKEN_DATE:" 延長代幣有效期限給",
    DELETE_TOKENS_FOR:" 刪除代幣給",
    PUMP_TYPE:"幫浦類型",
    TURN_OFF_DEVICE:" 裝置狀態",
    OPERATION_DATA:"操作數據",
    PUMP_DATA:"幫浦數據",
    PUMP_NAME:"幫浦名稱",
    POINT_NAME:"存取點名稱",
    CHANGER_INCOME:"按日期劃分的總販售機收入",
    SELECTED_OPEN:" 在選定的工作時間開放",
    ALWAYS_OPEN:"全天候開放(24/7)",
    CLOSED:" 關閉",
    CLOSED_24:" 24小時休息",
    OPENED_24:" 24小時營業",
    MON:" 週一",
    TUE:" 週二",
    WED:" 週三",
    THU:" 週四",
    FRI:" 週五",
    SAT:" 週六",
    SUN:" 週日",
    PRICING:"定價",
    PRICE:" 價格",
    VALIDITY:" 有效性",
    TOKEN_PACKAGES:"代幣包裝/套",
    SINGLE_WASH:"單次清洗",
    FACILITY_WORKING_HOURS:"設置所選設施的工作時間",
    WORKING_HOURS_ALWAYS_OPEN:"全天候開啟",
    WORKING_HOURS_ALWAYS_CLOSE:"被操作者關閉",
    WORKING_HOURS_CUSTOM:" 設定工作時間",
    KARCHER_ERROR_CODE:" 警報錯誤代碼",
    KARCHER_ERROR_MESSAGE_1:"電子插座過載",
    KARCHER_ERROR_MESSAGE_2:" 必須清空油水分離器",
    KARCHER_ERROR_MESSAGE_4:"調光感測器故障",
    KARCHER_ERROR_MESSAGE_5:" 高壓幫浦上的保護馬達開關被觸發",
    KARCHER_ERROR_MESSAGE_6:"RDS 連接故障",
    KARCHER_ERROR_MESSAGE_7:"壓縮機上的空氣壓力開關沒有回報任何",
    KARCHER_ERROR_MESSAGE_8:" 原因：未連接到電子設備“MSWS”。",
    KARCHER_ERROR_MESSAGE_10:"清洗站1沒有連接到的幫浦電子設備",
    KARCHER_ERROR_MESSAGE_11:"清洗站1的電子插座超載",
    KARCHER_ERROR_MESSAGE_12:" 清洗站1的高壓幫浦電流過高",
    KARCHER_ERROR_MESSAGE_13:" 清洗站1的高壓幫浦電流過低",
    KARCHER_ERROR_MESSAGE_14:"清洗站1高壓幫浦的觸點卡住",
    KARCHER_ERROR_MESSAGE_15:"清洗站1半載閥異常",
    KARCHER_ERROR_MESSAGE_16:"清洗站1高壓幫浦的線圈保護接點",
    KARCHER_ERROR_MESSAGE_17:" 清洗站1高壓幫浦油位過低",
    KARCHER_ERROR_MESSAGE_18:"清洗站1的電子設備有異常",
    KARCHER_ERROR_MESSAGE_19:"清洗站1的高壓幫浦馬達斷路器已跳脫",
    KARCHER_ERROR_MESSAGE_20:"未連接到清洗站 1 的遠端控制電子設備",
    KARCHER_ERROR_MESSAGE_21:" 清洗站1的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_22:" 清洗站1的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_30:"沒有連接到清洗站 2 的幫浦電子設備",
    KARCHER_ERROR_MESSAGE_31:"清洗站2的電子插座超載",
    KARCHER_ERROR_MESSAGE_32:"清洗站2的高壓幫浦電流過高",
    KARCHER_ERROR_MESSAGE_33:"清洗站2的高壓幫浦電流過低",
    KARCHER_ERROR_MESSAGE_34:"清洗站2高壓幫浦的接點卡住",
    KARCHER_ERROR_MESSAGE_35:"清洗站2半載閥異常",
    KARCHER_ERROR_MESSAGE_36:"清洗站2高壓幫浦的線圈保護接點",
    KARCHER_ERROR_MESSAGE_37:"清洗站2高壓幫浦油位過低",
    KARCHER_ERROR_MESSAGE_38:"清洗站2的電子設備有異常",
    KARCHER_ERROR_MESSAGE_39:"清洗站2高壓幫浦馬達斷路器已跳脫",
    KARCHER_ERROR_MESSAGE_40:"清洗站2沒有連接到遠端控制電子設備",
    KARCHER_ERROR_MESSAGE_41:"清洗站2的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_42:"清洗站2的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_50:"沒有連接到清洗站3的幫浦電子設備",
    KARCHER_ERROR_MESSAGE_51:"清洗站3的電子插座超載",
    KARCHER_ERROR_MESSAGE_52:"清洗站3的高壓幫浦電流過高",
    KARCHER_ERROR_MESSAGE_53:"清洗站3的高壓幫浦電流過低",
    KARCHER_ERROR_MESSAGE_54:"清洗站3高壓幫浦的接點卡住",
    KARCHER_ERROR_MESSAGE_55:"清洗站3半載閥異常",
    KARCHER_ERROR_MESSAGE_56:"清洗站3高壓幫浦的線圈保護接點",
    KARCHER_ERROR_MESSAGE_57:"清洗站3高壓幫浦油位過低",
    KARCHER_ERROR_MESSAGE_58:"清洗站3的電子設備有異常",
    KARCHER_ERROR_MESSAGE_59:"清洗站3高壓幫浦的馬達斷路器已跳脫",
    KARCHER_ERROR_MESSAGE_60:"清洗站3沒有連接到遠端控制電子設備",
    KARCHER_ERROR_MESSAGE_61:"清洗站3的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_62:"清洗站3的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_70:"沒有連接到清洗站4的幫浦電子設備",
    KARCHER_ERROR_MESSAGE_71:"清洗站4的電子插座超載",
    KARCHER_ERROR_MESSAGE_72:"清洗站4的高壓幫浦電流過高",
    KARCHER_ERROR_MESSAGE_73:"清洗站4的高壓幫浦電流過低",
    KARCHER_ERROR_MESSAGE_74:"清洗站4高壓幫浦的接點卡住",
    KARCHER_ERROR_MESSAGE_75:"清洗站4半載閥異常",
    KARCHER_ERROR_MESSAGE_76:"清洗站4高壓幫浦的線圈保護接點",
    KARCHER_ERROR_MESSAGE_77:"清洗站4高壓幫浦油位過低",
    KARCHER_ERROR_MESSAGE_78:"清洗站4的電子設備有異常",
    KARCHER_ERROR_MESSAGE_79:"清洗站4的高壓幫浦馬達斷路器已跳脫",
    KARCHER_ERROR_MESSAGE_80:"清洗站4沒有連接到遠端控制電子設備",
    KARCHER_ERROR_MESSAGE_81:"清洗站4的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_82:"清洗站4的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_90:"沒有連接到清洗站5的幫浦電子設備",
    KARCHER_ERROR_MESSAGE_91:"清洗站5的電子插座超載",
    KARCHER_ERROR_MESSAGE_92:"清洗站5的高壓幫浦電流過高",
    KARCHER_ERROR_MESSAGE_93:"清洗站5的高壓幫浦電流過低",
    KARCHER_ERROR_MESSAGE_94:"清洗站5高壓幫浦的接點卡住",
    KARCHER_ERROR_MESSAGE_95:"清洗站5半載閥異常",
    KARCHER_ERROR_MESSAGE_96:"清洗站5高壓幫浦的線圈保護接點",
    KARCHER_ERROR_MESSAGE_97:"清洗站5高壓幫浦油位過低",
    KARCHER_ERROR_MESSAGE_98:"清洗站5的電子設備有異常",
    KARCHER_ERROR_MESSAGE_99:"清洗站5的高壓幫浦馬達斷路器已跳脫",
    KARCHER_ERROR_MESSAGE_100:"沒有連接到清洗站5的遠端控制電子設備",
    KARCHER_ERROR_MESSAGE_101:"清洗站5的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_102:"清洗站5的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_110:"沒有連接到清洗站6的幫浦電子設備",
    KARCHER_ERROR_MESSAGE_111:"清洗站6的電子插座超載",
    KARCHER_ERROR_MESSAGE_112:"清洗站6的高壓幫浦電流過高",
    KARCHER_ERROR_MESSAGE_113:"清洗站6的高壓幫浦電流過低",
    KARCHER_ERROR_MESSAGE_114:"清洗站6高壓幫浦的接點卡住",
    KARCHER_ERROR_MESSAGE_115:"清洗站6半載閥異常",
    KARCHER_ERROR_MESSAGE_116:"清洗站6高壓幫浦的線圈保護接點",
    KARCHER_ERROR_MESSAGE_117:"清洗站6高壓幫浦油位過低",
    KARCHER_ERROR_MESSAGE_118:"清洗站6的電子設備有異常",
    KARCHER_ERROR_MESSAGE_119:"清洗站6高壓幫浦馬達斷路器已跳脫",
    KARCHER_ERROR_MESSAGE_120:"沒有連接到清洗站6的遠端控制電子設備",
    KARCHER_ERROR_MESSAGE_121:"清洗站6的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_122:"清洗站6的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_130:"清洗站7沒有連接到的幫浦電子設備",
    KARCHER_ERROR_MESSAGE_131:"清洗站7的電子插座超載",
    KARCHER_ERROR_MESSAGE_132:"清洗站7的高壓幫浦電流過高",
    KARCHER_ERROR_MESSAGE_133:"清洗站7的高壓幫浦電流過低",
    KARCHER_ERROR_MESSAGE_134:"清洗站7高壓幫浦的接點卡住",
    KARCHER_ERROR_MESSAGE_135:"清洗站7半載閥異常",
    KARCHER_ERROR_MESSAGE_136:"清洗站7高壓幫浦的線圈保護接點",
    KARCHER_ERROR_MESSAGE_137:"清洗站7高壓幫浦油位過低",
    KARCHER_ERROR_MESSAGE_138:"清洗站7的電子設備有異常",
    KARCHER_ERROR_MESSAGE_139:"清洗站7的高壓幫浦馬達斷路器已跳脫",
    KARCHER_ERROR_MESSAGE_140:"沒有連接到清洗站7的遠端控制電子設備",
    KARCHER_ERROR_MESSAGE_141:"清洗站7的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_142:"清洗站7的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_150:"沒有連接到清洗站8的幫浦電子設備",
    KARCHER_ERROR_MESSAGE_151:"清洗站8的電子插座超載",
    KARCHER_ERROR_MESSAGE_152:"清洗站8的高壓幫浦電流過高",
    KARCHER_ERROR_MESSAGE_153:"清洗站8的高壓幫浦電流過低",
    KARCHER_ERROR_MESSAGE_154:"清洗站8高壓幫浦的接點卡住",
    KARCHER_ERROR_MESSAGE_155:"清洗站8半載閥異常",
    KARCHER_ERROR_MESSAGE_156:"清洗站8高壓幫浦的線圈保護接點",
    KARCHER_ERROR_MESSAGE_157:"清洗站8高壓幫浦油位過低",
    KARCHER_ERROR_MESSAGE_158:"清洗站8的電子設備有異常",
    KARCHER_ERROR_MESSAGE_159:"清洗站8的高壓幫浦馬達斷路器已跳脫",
    KARCHER_ERROR_MESSAGE_160:"沒有連接到清洗站8的遠端控制電子設備",
    KARCHER_ERROR_MESSAGE_161:"清洗站8的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_162:"清洗站8的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_170:" 未連接電子設備 A2",
    KARCHER_ERROR_MESSAGE_171:" 電子設備 A2 的輸出過載",
    KARCHER_ERROR_MESSAGE_172:"清潔劑容器已空",
    KARCHER_ERROR_MESSAGE_173:"清潔劑容器已空",
    KARCHER_ERROR_MESSAGE_174:"清潔劑容器已空",
    KARCHER_ERROR_MESSAGE_175:"清潔劑容器已空",
    KARCHER_ERROR_MESSAGE_176:"清潔劑容器已空",
    KARCHER_ERROR_MESSAGE_177:"底盤清洗的幫浦電流過高",
    KARCHER_ERROR_MESSAGE_178:"開啟車身底部清洗後無壓力",
    KARCHER_ERROR_MESSAGE_190:" 未連接電子設備 A3",
    KARCHER_ERROR_MESSAGE_191:" 電子設備 A3 的輸出過載",
    KARCHER_ERROR_MESSAGE_200:"WSO 的控制和電子設備之間沒有連接",
    KARCHER_ERROR_MESSAGE_201:"WSO 的控制輸出過載",
    KARCHER_ERROR_MESSAGE_202:"再生後硬度感測器顯示硬水",
    KARCHER_ERROR_MESSAGE_204:" 電子設備故障",
    KARCHER_ERROR_MESSAGE_210:"液位感測器緩衝罐淨空啟動",
    KARCHER_ERROR_MESSAGE_211:"液位感測器緩衝容器空和緩衝容器滿同時切換",
    KARCHER_ERROR_MESSAGE_212:"液位感測器RO幫浦開啟和緩衝容器滿開關同時進行",
    KARCHER_ERROR_MESSAGE_213:" 無水壓",
    KARCHER_ERROR_MESSAGE_214:"現場備水報告異常",
    KARCHER_ERROR_MESSAGE_220:" 缺水",
    KARCHER_ERROR_MESSAGE_221:" 排氣溫度過高",
    KARCHER_ERROR_MESSAGE_222:"溫水循環幫浦電流過高",
    KARCHER_ERROR_MESSAGE_223:" 燃燒器故障",
    KARCHER_ERROR_MESSAGE_224:" 燃燒器的安全恆溫器已觸發",
    KARCHER_ERROR_MESSAGE_225:" 燃燒器延遲啟動",
    KARCHER_ERROR_MESSAGE_226:"溫水循環幫浦關閉後5秒內流量指示器未開啟",
    KARCHER_ERROR_MESSAGE_227:" 溫水循環幫浦關閉後3秒內流量指示器未關閉",
    KARCHER_ERROR_MESSAGE_228:" 燃燒器關閉後熱水出口冷卻過慢",
    KARCHER_ERROR_MESSAGE_229:"溫水溫度感測器故障",
    KARCHER_ERROR_MESSAGE_230:" 燃燒器出口溫度感測器故障",
    KARCHER_ERROR_MESSAGE_231:" 溫水溫度感測器故障",
    KARCHER_ERROR_MESSAGE_232:" 燃燒器出口溫度感測器故障",
    KARCHER_ERROR_MESSAGE_233:" 外部供應溫水水溫高於60°C",
    KARCHER_ERROR_MESSAGE_234:"防軍團菌程序錯誤",
    KARCHER_ERROR_MESSAGE_235:"未達抗軍團菌溫水溫度",
    KARCHER_ERROR_MESSAGE_240:" 外部溫度感測器故障",
    KARCHER_ERROR_MESSAGE_241:" 外部溫度感測器故障",
    KARCHER_ERROR_MESSAGE_242:"防凍保護循環幫浦的電流過高",
    KARCHER_ERROR_MESSAGE_243:"清洗站加熱器循環幫浦的電流過高",
    KARCHER_ERROR_MESSAGE_244:"溫水溫度過低，清洗站加熱器已關閉。",
    KARCHER_ERROR_MESSAGE_245:" 泡沫軟管加熱器的電流消耗過高",
    KARCHER_ERROR_MESSAGE_247:" 電子設備故障",
    KARCHER_ERROR_MESSAGE_248:"電子設備故障",
    KARCHER_ERROR_MESSAGE_250:"特殊清洗程序的幫浦電流過高",
    KARCHER_ERROR_MESSAGE_255:" 電子設備故障",
    KARCHER_ERROR_MESSAGE_260:" 未連接電子設備 A5",
    KARCHER_ERROR_MESSAGE_261:" 電子設備 A5 的輸出過載",
    KARCHER_ERROR_MESSAGE_280:" 未連接電子設備 A6",
    KARCHER_ERROR_MESSAGE_281:" 電子設備 A6 的輸出過載",
    KARCHER_ERROR_MESSAGE_282:" 輪圈清潔的幫浦電流消耗過高",
    KARCHER_ERROR_MESSAGE_283:" 輪圈清潔的幫浦電流消耗太低",
    KARCHER_ERROR_MESSAGE_284:" 輪圈清潔幫浦接觸器卡住",
    KARCHER_ERROR_MESSAGE_300:" 未連接電子設備 A7",
    KARCHER_ERROR_MESSAGE_301:" 電子設備 A7 的輸出過載",
    KARCHER_ERROR_MESSAGE_320:"未連接電子設備 A8",
    KARCHER_ERROR_MESSAGE_321:"電子設備 A8 的輸出過載",
    KARCHER_ERROR_MESSAGE_322:"微乳化液幫浦電流消耗過高",
    KARCHER_ERROR_MESSAGE_323:" 微乳化液幫浦電流消耗過低",
    KARCHER_ERROR_MESSAGE_324:"微乳化液幫浦接觸器卡住",
    KARCHER_ERROR_MESSAGE_340:" 未連接電子設備 A9",
    KARCHER_ERROR_MESSAGE_341:"電子設備 A9 的輸出過載",
    KARCHER_ERROR_MESSAGE_342:" 強化清洗幫浦的電流消耗過高",
    KARCHER_ERROR_MESSAGE_343:" 強化清洗幫浦的電流消耗過低",
    KARCHER_ERROR_MESSAGE_344:"強化清洗幫浦接觸器卡住",
    KARCHER_ERROR_MESSAGE_400:" 溫水無壓力",
    KARCHER_ERROR_MESSAGE_401:"淡水無壓力",
    KARCHER_ERROR_MESSAGE_402:" 滲透無壓力",
    KARCHER_ERROR_MESSAGE_403:"4. 水類型無壓力",
    KARCHER_ERROR_MESSAGE_404:"4.水類型、溫度超過60°C或外部干擾。",
    KARCHER_ERROR_MESSAGE_405:"防凍無壓力",
    KARCHER_ERROR_MESSAGE_406:" 儘管防凍幫浦已關閉，但防凍保護仍有壓力。",
    KARCHER_ERROR_MESSAGE_410:" 24 小時內出現 4 次錯誤 F 400",
    KARCHER_ERROR_MESSAGE_411:"錯誤 F 401 已啟動 300 秒。",
    KARCHER_ERROR_MESSAGE_412:" 24 小時內出現 4 次錯誤 F 402",
    KARCHER_ERROR_MESSAGE_413:" 24 小時內出現 4 次錯誤 F 403",
    KARCHER_ERROR_MESSAGE_414:" 24 小時內出現 4 次錯誤 F 405",
    KARCHER_ERROR_MESSAGE_420:"錯誤代幣兌幣機 1",
    KARCHER_ERROR_MESSAGE_421:"錯誤代幣兌幣機 2",
    KARCHER_ERROR_MESSAGE_440:"未連接電子設備 A31",
    KARCHER_ERROR_MESSAGE_441:" 電子設備 A31 的輸出過載",
    KARCHER_ERROR_MESSAGE_500:"吸塵器電子設備的連接 1/2",
    KARCHER_ERROR_MESSAGE_501:"吸塵器1啟動按鈕永久觸點",
    KARCHER_ERROR_MESSAGE_502:"吸塵器2啟動按鈕永久觸點",
    KARCHER_ERROR_MESSAGE_510:"吸塵器電子設備的連接 3/4",
    KARCHER_ERROR_MESSAGE_511:"吸塵器3永久觸點的啟動按鈕",
    KARCHER_ERROR_MESSAGE_512:"吸塵器4永久觸點的啟動按鈕",
    KARCHER_ERROR_MESSAGE_520:" 吸塵器電子設備的連接 5/6",
    KARCHER_ERROR_MESSAGE_521:"吸塵器5永久觸點的啟動按鈕",
    KARCHER_ERROR_MESSAGE_522:"吸塵器6永久觸點的啟動按鈕",
    KARCHER_ERROR_MESSAGE_530:"吸塵器電子設備的連接 7/8",
    KARCHER_ERROR_MESSAGE_531:"吸塵器7永久觸點的啟動按鈕",
    KARCHER_ERROR_MESSAGE_532:"吸塵器8永久觸點的啟動按鈕",
    KARCHER_ERROR_MESSAGE_540:"吸塵器電子設備的連接 9/10",
    KARCHER_ERROR_MESSAGE_541:"吸塵器9永久觸點的啟動按鈕",
    KARCHER_ERROR_MESSAGE_542:"吸塵器10永久觸點的啟動按鈕",
    KARCHER_ERROR_MESSAGE_550:"吸塵器電子設備的連接 10/11",
    KARCHER_ERROR_MESSAGE_551:"吸塵器11永久觸點的啟動按鈕",
    KARCHER_ERROR_MESSAGE_552:"吸塵器12永久觸點的啟動按鈕",
    KARCHER_ERROR_MESSAGE_800:"未連接電子設備 A30",
    KARCHER_ERROR_MESSAGE_801:" 電子設備 A30 的輸出過載",
    KARCHER_ERROR_MESSAGE_802:" 軟化裝置故障",
    KARCHER_ERROR_MESSAGE_803:"預壓幫浦 RO 保護馬達開關跳脫",
    KARCHER_INFO_MESSAGE_1:"基礎交換器再生開始",
    KARCHER_INFO_MESSAGE_2:"基礎交換器再生完成",
    KARCHER_INFO_MESSAGE_3:"基礎交換器耗盡 75%",
    KARCHER_INFO_MESSAGE_4:" 由於技術問題，單位無法使用。",
    KARCHER_INFO_MESSAGE_5:" 由於操作問題，單位無法使用。",
    KARCHER_INFO_MESSAGE_6:" 單位已開啟",
    KARCHER_INFO_MESSAGE_10:"即使是在營業時間內",
    KARCHER_INFO_MESSAGE_11:"Bay 1不可用",
    KARCHER_INFO_MESSAGE_12:"Bay 2不可用",
    KARCHER_INFO_MESSAGE_13:"Bay 3不可用",
    KARCHER_INFO_MESSAGE_14:"Bay 4不可用",
    KARCHER_INFO_MESSAGE_15:"Bay 5不可用",
    KARCHER_INFO_MESSAGE_16:"Bay 6不可用",
    KARCHER_INFO_MESSAGE_17:"Bay 7不可用",
    KARCHER_INFO_MESSAGE_18:"Bay 8不可用",
    KARCHER_INFO_MESSAGE_20:"抗軍團菌程式溫水箱",
    KARCHER_INFO_MESSAGE_21:"抗軍團菌程式HD幫浦1必要的",
    KARCHER_INFO_MESSAGE_22:"抗軍團菌程式HD幫浦2必要的",
    KARCHER_INFO_MESSAGE_23:"抗軍團菌程式HD幫浦3必要的",
    KARCHER_INFO_MESSAGE_24:"抗軍團菌程式HD幫浦4必要的",
    KARCHER_INFO_MESSAGE_25:"抗軍團菌程式HD幫浦5必要的",
    KARCHER_INFO_MESSAGE_26:"抗軍團菌程式HD幫浦6必要的",
    KARCHER_INFO_MESSAGE_27:"抗軍團菌程式HD幫浦7必要的",
    KARCHER_INFO_MESSAGE_28:"抗軍團菌程式HD幫浦8必要的",
    KARCHER_INFO_MESSAGE_29:" 抗軍團菌程序完成",
    KARCHER_INFO_MESSAGE_101:" 高壓幫浦 1 需要維修",
    KARCHER_INFO_MESSAGE_102:" 高壓幫浦 2 需要維修",
    KARCHER_INFO_MESSAGE_103:" 高壓幫浦 3 需要維修",
    KARCHER_INFO_MESSAGE_104:" 高壓幫浦 4 需要維修",
    KARCHER_INFO_MESSAGE_105:" 高壓幫浦 5 需要維修",
    KARCHER_INFO_MESSAGE_106:" 高壓幫浦 6 需要維修",
    KARCHER_INFO_MESSAGE_107:" 高壓幫浦 7 需要維修",
    KARCHER_INFO_MESSAGE_108:" 高壓幫浦 8 需要維修",
    KARCHER_INFO_MESSAGE_109:" 燃燒器需要維修",
    KARCHER_INFO_MESSAGE_110:"燃燒器風機需要維修",
    KARCHER_INFO_MESSAGE_111:" 溫水幫浦需要維修",
    KARCHER_INFO_MESSAGE_112:" 防凍幫浦需要維修",
    KARCHER_INFO_MESSAGE_113:" 滲透幫浦需要維修",
    KARCHER_INFO_MESSAGE_114:" 地暖幫浦需要維修",
    KARCHER_INFO_MESSAGE_115:"加熱管需要維修",
    KARCHER_INFO_MESSAGE_116:" 微化乳液/輪圈清潔劑幫浦需要維修",
    KARCHER_INFO_MESSAGE_117:"底盤清潔幫浦需要維修",
    KARCHER_INFO_MESSAGE_118:"系統壓力幫浦需要維修",
    KARCHER_INFO_MESSAGE_119:" 吸塵器 1 需要維修",
    KARCHER_INFO_MESSAGE_120:"吸塵器 2 需要維修",
    KARCHER_INFO_MESSAGE_121:"吸塵器 3 需要維修",
    KARCHER_INFO_MESSAGE_122:"吸塵器 4 需要維修",
    KARCHER_INFO_MESSAGE_123:"吸塵器 5 需要維修",
    KARCHER_INFO_MESSAGE_124:"吸塵器 6 需要維修",
    KARCHER_INFO_MESSAGE_125:"吸塵器 7 需要維修",
    KARCHER_INFO_MESSAGE_126:"吸塵器 8 需要維修",
    KARCHER_INFO_MESSAGE_127:"吸塵器 9 需要維修",
    KARCHER_INFO_MESSAGE_128:"吸塵器 10 需要維修",
    KARCHER_INFO_MESSAGE_129:"吸塵器 11 需要維修",
    KARCHER_INFO_MESSAGE_130:"吸塵器 12 需要維修",
    KARCHER_INFO_MESSAGE_131:"輪圈清潔劑幫浦需要維修",
    KARCHER_INFO_MESSAGE_132:"微乳化液幫浦需要維修",
    KARCHER_INFO_MESSAGE_133:"強力泡沫幫浦需要維修",
    KARCHER_INFO_MESSAGE_142:"吸塵器 1 渦輪機需要維修",
    KARCHER_INFO_MESSAGE_143:"吸塵器 1 過濾器需要維修",
    KARCHER_INFO_MESSAGE_144:"吸塵器 2 渦輪機需要維修",
    KARCHER_INFO_MESSAGE_145:"吸塵器 2 過濾器需要維修",
    KARCHER_INFO_MESSAGE_146:"吸塵器 3 渦輪機需要維修",
    KARCHER_INFO_MESSAGE_147:" 吸塵器 3 過濾器需要維修",
    KARCHER_INFO_MESSAGE_148:"吸塵器 4 渦輪機需要維修",
    KARCHER_INFO_MESSAGE_149:" 吸塵器 4 過濾器需要維修",
    KARCHER_INFO_MESSAGE_150:" 吸塵器 5 渦輪機需要維修",
    KARCHER_INFO_MESSAGE_151:"吸塵器 5 過濾器需要維修",
    KARCHER_INFO_MESSAGE_152:"吸塵器 6 渦輪機需要維修",
    KARCHER_INFO_MESSAGE_153:"吸塵器 6 過濾器需要維修",
    KARCHER_INFO_MESSAGE_154:"吸塵器 7 渦輪機需要維修",
    KARCHER_INFO_MESSAGE_155:"吸塵器 7 過濾器需要維修",
    KARCHER_INFO_MESSAGE_156:"吸塵器 8 渦輪機需要維修",
    KARCHER_INFO_MESSAGE_157:"吸塵器 8 過濾器需要維修",
    KARCHER_INFO_MESSAGE_158:"吸塵器 9 渦輪機需要維修",
    KARCHER_INFO_MESSAGE_159:"吸塵器 9 過濾器需要維修",
    KARCHER_INFO_MESSAGE_160:"吸塵器 10 渦輪機需要維修",
    KARCHER_INFO_MESSAGE_161:"吸塵器 10 過濾器需要維修",
    KARCHER_INFO_MESSAGE_162:"吸塵器 11 渦輪機需要維修",
    KARCHER_INFO_MESSAGE_163:"吸塵器 11 過濾器需要維修",
    KARCHER_INFO_MESSAGE_164:"吸塵器 12 渦輪機需要維修",
    KARCHER_INFO_MESSAGE_165:" 吸塵器 12 過濾器需要維修",
    ORGANIZATION:"組織",
    CREATE_ORGANIZATION:"創建組織",
    CREATE_ORGANIZATION_AS:"建立組織作為子組織給",
    DELETE_ORGANIZATION:"刪除組織",
    EDIT_ORGANIZATION:"編輯組織",
    SUPPORTED_ORG_NAME:"支援組織",
    SUPPORTED_ORG_TYPE:" 支援類型",
    ORG_NAME:"名稱",
    ORG_TYPE:"類型",
    SET_ORG_TITLE:"設定子組織",
    SET_SUPPORTED_ORG_TITLE:"設定支援子組織",
    SAVE_ORGANIZATION:"保存組織",
    SELECT_ORGANIZATION_TYPE:"選擇組織類型",
    SELECT_ORGANIZATION_SELECTOR:"選擇",
    SELECT_SUPPORTED_ORGANIZATION:"選擇支援組織",
    ORGANIZATION_DELETED:"組織已成功刪除",
    ORGANIZATION_SAVED:"組織已成功保存",
    ORGANIZATION_UPDATED:"組織已成功更新",
    ALERTS:"警報",
    DEVICE_STATUS:"裝置狀態",
    SITE_DETAILS:"場地詳情",
    ALARM_STATUS:"警報狀態",
    FILTER:"過濾 ...",
    FILTER_BY_ALERT_CENTER:"按代碼、名稱或描述過濾",
    TOTAL_ALARM:"總計",
    LOW_ALARM:"事件",
    MEDIUM_ALARM:"故障",
    HIGH_ALARM:"嚴重錯誤",
    NO_FACILITIES_NEARBY:"附近沒有設備",
    GRAY_MAP:"灰色風格地圖",
    READY:"預備",
    WARNING:"故障",
    ERROR:"錯誤",
    SITE_NAME:"場域名稱",
    ACCOUNTS_INFO:"帳戶資訊",
    USER_ORGANIZATION:"使用者組織",
    ADD_USER_ORGANIZATION:" 新增新的組織用戶",
    EDIT_USER_ORGANIZATION:"編輯組織用戶",
    SELECT_ROLE:"選擇角色",
    SELECT_ORGANIZATION:"選擇組織",
    SELECT_USER:"選擇用戶",
    USER_FOR_ORGANIZATION_CREATED:"新用戶創建成功",
    SELECT_REGION:" 選擇地區",
    SELECT_LANGUAGE:"選擇語言",
    LOADING_DATA:" 正在載入資訊，請稍候...",
    ADMINISTRATOR:"管理人員",
    TECHNICAL_SUPPORT:"技術支援",
    CONTROLLER:"控制器",
    EDIT_ORGANIZATION_USER:"編輯組織用戶",
    DELETE_ORGANIZATION_USER:"刪除組織用戶",
    USER_UPDATED:"用戶更新成功",
    USER_CREATED:"使用者創建成功",
    ADDRESS:"地址",
    SUBSCRIPTIONS:" 訂閱",
    RESOLVED_STATUS:"解決",
    NOT_RESOLVED_STATUS:" 未解決",
    ALERT_NAME:"警報名稱",
    ALERT_DESCRIPTION:"警報說明",
    ALERT_CODE:"警報代碼",
    ALERT_TYPE:"警報類型",
    UNSUBSCRIBE:"取消訂閱警報",
    SUBSCRIBE:"訂閱警報",
    ALARM_SUBSCRIBED:"訂閱成功",
    UNSUBSCRIBED_CONFIRM:"取消訂閱？",
    ALARM_UNSUBSCRIBED:"取消訂閱成功",
    ASIDE_MENU_CASHLESS_SALES:"非現金銷售",
    FILTERED_CASHLESS_PAYMENTS:"過濾非現金支付",
    REFUND_DIALOG_TITLE:"交易退款？",
    REFUND_DIALOG_SUBTITLE:"金額可以小於或等於交易金額",
    REFUND:"退款",
    INPUT_NOT_VALID:"輸入無效",
    REFUND_SUCCESSFULLY:"所選付款的退款已成功完成",
    USER:"使用者",
    TRANSACTION_ID:"PSP 參考",
    DEVICE_ID:"裝置ID",
    NET_AMOUNT:"淨額",
    REPORT_NAME:"報告名稱",
    TIME_FRAME:"時間範圍",
    SUB_POINT:"選擇子點",
    SUB_POINT_LIST_NOT_EXIST:"所選清洗設施不存在子點列表",
    FACILITY_TYPE:"設施類型",
    MACHINE_NAME:"機器名稱",
    WASH_FACILITY_DETAILS:"清洗設施詳情",
    WASH_BAY_DETAILS:"洗車格詳情",
    DEVICES_INFO:"裝置列表",
    OPERATION_TIME_INFO:"運作時間",
    OPERATION_TIME_VACUUM_INFO:"吸塵器的運作時間",
    OPERATION_TIME_ILLUMINATION_INFO:"照明的運轉時間",
    AVAILABLE_TITLE:"可用的",
    UNAVAILABLE_TITLE:"不可用",
    CURRENT_PROGRAM:"目前程序",
    CREDITS:"帳面餘額",
    DEVICE_NAME:"裝置名稱",
    ACTIVE_ALARMS:"未解除警報",
    ALL_DAY:"全天",
    OPERATING_TIME_WASH_FACILITY:"自助洗系統",
    OPERATING_TIME_VACUUMS:"吸塵器",
    OPERATING_TIME_ILLUMINATION:"照明",
    OPERATION_COUNTERS:"操作櫃檯",
    EDIT:"編輯",
    WASHING_PROGRAMS:"清洗程序",
    INFO:" 事件",
    STATISTIC:"統計",
    ROLLOVER_DOSING:"劑量",
    ROLLOVER_SPEED:"速度",
    ROLLOVER_RESETS:"龍門遠端重置",
    ROLLOVER_RESETS_INFO:"遠端重置必須符合當地法規。重要提示：重置之前，請確保累計為空。",
    RESET_ROLLOVER:"重置龍門",
    OPEN_DOOR_ROLLOVER:"打開",
    ROLLOVER_OPEN_DOOR_INFO:"打開清潔室門。請小心",
    ROLLOVER_OPEN_DOOR:"開門",
    APPLY_DOSING_CHANGES:"運用劑量改變",
    APPLY_SPEED_CHANGES:"運用速度改變",
    ACTUATION_SUCCESS:"請求已發送",
    REMAINING_TIME:"剩餘時間",
    OPEN_24H:"24小時營業",
    CLOSE_24H:"24小時關閉",
    VALIDATION_OPERATION_TIME:"格式不正確。請用 hh:mm",
    ROLLOVER:"龍門洗車機",
    UPDATE_WASHING_PROGRAM:"更新洗滌程序",
    UPDATE_ACTUATORS:"更新促動器",
    OPEN_ROLOVER_DOOR_TITLE:"要打開龍門門口嗎?",
    OPEN_ROLOVER_DOOR_CONTENT:"您確定要開門嗎？",
    RESET_ROLOVER_TITLE:"想要重置龍門洗車機？",
    RESET_ROLOVER_CONTENT:"您確定想要重置龍門洗車機？",
    G0:"{{brand === 'r2w' ? '灣 0' : '灣 1'}}",
    G1:"{{brand === 'r2w' ? '灣 1' : '灣 2'}}",
    G2:"{{brand === 'r2w' ? '灣 2' : '灣 3'}}",
    G3:"{{brand === 'r2w' ? '灣 3' : '灣 4'}}",
    G4:"{{brand === 'r2w' ? '灣 4' : '灣 5'}}",
    G5:"{{brand === 'r2w' ? '灣 5' : '灣 6'}}",
    G6:"{{brand === 'r2w' ? '灣 6' : '灣 7'}}",
    G7:"{{brand === 'r2w' ? '灣 7' : '灣 8'}}",
    G8:"{{brand === 'r2w' ? '灣 8' : '灣 9'}}",
    G9:"{{brand === 'r2w' ? '灣 9' : '灣 10'}}",
    G10:"{{brand === 'r2w' ? '灣 10' : '灣 11'}}",
    U0:"{{brand === 'r2w' ? '吸塵器 0' : '吸塵器 1'}}",
    U1:"{{brand === 'r2w' ? '吸塵器 1' : '吸塵器 2'}}",
    U2:"{{brand === 'r2w' ? '吸塵器 2' : '吸塵器 3'}}",
    U3:"{{brand === 'r2w' ? '吸塵器 3' : '吸塵器 4'}}",
    U4:"{{brand === 'r2w' ? '吸塵器 4' : '吸塵器 5'}}",
    U5:"{{brand === 'r2w' ? '吸塵器 5' : '吸塵器 6'}}",
    U6:"{{brand === 'r2w' ? '吸塵器 6' : '吸塵器 7'}}",
    U7:"{{brand === 'r2w' ? '吸塵器 7' : '吸塵器 8'}}",
    ALERT_CENTER_TITLE_BY_SITE:"由儀表板中選定所在點建立的警報中心報告",
    ALERT_CENTER_TITLE_BY_FACILITY:"由儀表板中選定的設施所建立的警報中心報告",
    ALERT_CENTER_TITLE_BY_DEFAULT:"警報中心報告",
    ERROR_MESSAGE_403:"您無權使用此 api 要求。錯誤代碼：403",
    LAST_ACTIVE_PROGRAM:"有效程式/上次有效程式",
    PROGRAM_ID:"程式號碼",
    PROGRAM_PRICE:"程式價格",
    NORMAL_CHEMICAL_LEVEL:"好的",
    LOW_CHEMICAL_LEVEL:"需要補充",
    EMPTY_CHEMICAL_LEVEL:"空的",
    CHEMICAL_LEVEL:"清潔劑液位指示（%）",
    ROLLOVER_STATUS:"龍門洗車機狀態",
    ROLLOVER_STATUS_CODE_0:"目前清洗設備故障",
    ROLLOVER_STATUS_CODE_1:" 營業時間外",
    ROLLOVER_STATUS_CODE_2:"允許程式輸入",
    ROLLOVER_STATUS_CODE_3:" 定位您的車輛",
    ROLLOVER_STATUS_CODE_4:"車輛前進",
    ROLLOVER_STATUS_CODE_5:"車輛後退",
    ROLLOVER_STATUS_CODE_6:"車輛停止",
    ROLLOVER_STATUS_CODE_7:"清洗運行",
    ROLLOVER_STATUS_CODE_8:"清洗停止",
    ROLLOVER_STATUS_CODE_9:"清洗運行(tact)",
    ROLLOVER_STATUS_CODE_10:"向後退出車輛",
    ROLLOVER_STATUS_CODE_11:"緊急停止",
    ROLLOVER_STATUS_CODE_12:"向前退出車輛",
    ROLLOVER_STATUS_CODE_13:"抗凍運行中",
    ROLLOVER_STATUS_CODE_14:"安全開關正面啟動",
    ROLLOVER_STATUS_CODE_15:" 安全開關後方啟動",
    ROLLOVER_STATUS_CODE_16:" 安全開關左前側啟動",
    ROLLOVER_STATUS_CODE_17:" 安全開關右前側啟動",
    ROLLOVER_STATUS_CODE_18:"安全開關左後側啟動",
    ROLLOVER_STATUS_CODE_19:"安全開關右後側啟動",
    ROLLOVER_STATUS_CODE_20:"車輛位置太靠左側",
    ROLLOVER_STATUS_CODE_21:"車輛位置太靠右側",
    ROLLOVER_STATUS_CODE_22:"左門未關",
    ROLLOVER_STATUS_CODE_23:"右門未關",
    ROLLOVER_STATUS_CODE_24:"偵測到輸送機購，選擇了錯誤的清洗程序。",
    ROLLOVER_STATUS_CODE_25:" 喇叭感應器",
    ROLLOVER_STATUS_CODE_98:"手動/調節模式",
    ROLLOVER_STATUS_CODE_99:"狀態未知",
    ROLLOVER_STATUS_CODE_UNDEFINED:"狀態碼未定義",
    ALARM:"嚴重錯誤",
    NO_ALARM:"無嚴重錯誤",
    SOFTWARE_VERSION:"軟體版本",
    SOFTWARE_DATE:"軟體日期",
    SITE_ADDRESS:"站址",
    SECONDS:"秒數",
    SERVICE_PART_NAME:"服務名稱：",
    OPERATION_SERVICE_COUNTER_ROLLOVER:"操作及服務計數器",
    OPERATION_COUNTER:"操作計數器",
    SERVICE_COUNTER:" 服務計數器",
    FAULT_CODE:"警報代碼",
    PRESSURE_TITLE:"空氣壓力",
    TIME_TITLE:"目前時間",
    COUNTRY_TITLE:"國家",
    CITY_TITLE:"城市",
    REGION_TITLE:"地區",
    SELECT_POINTS_TO_SEARCH:"選擇要點 ...",
    LOGS_HISTORY:"參數變更歷史",
    ACTUATOR_REFERENCE:"執行器參考",
    ACTUATOR_VALUE:"執行器數值",
    POINT_ID:"要點ID",
    VALIDATION_NOT_VALID_RANGE:"範圍不正確",
    ENABLE_ROLLOVER_RESET:"勾選此方塊即表示您確認已閱讀並同意安全說明。",
    CHANGE_OF_PARAMETERS:"參數變更",
    SELECT_OPTIONS:"選擇選項",
    AUTOMATIC:"自動的",
    DESALTING:"去鹽功能",
    SEASON_WASH:"季節清洗程序",
    SPRING_PROGRAM:"春季清洗程序",
    SUMMER_PROGRAM:" 夏季清洗程序",
    AUTUMN_PROGRAM:"秋季清洗程序",
    WINTER_PROGRAM:"冬季清洗程序",
    DOOR_CONTROL:"門控",
    SUMMER_DOOR_CONTROL:"夏季，在夏季模式下透過門控進行操作。",
    WINTER_DOOR_CONTROL:"冬季，在冬季模式下透過門控進行操作。",
    APPLY_PARAMETERS_CHANGES:"應用參數更改",
    WORKING_SCHEDULES:"工作時間表",
    HOLIDAY_SCHEDULES:"假日行程",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:"場址假期創建成功",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"場址假期已成功更新",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:"場址假期已成功刪除",
    WORKING_SCHEDULES_SUCCESSFULLY_UPDATED:"工作計劃已成功更新",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"工作計劃宣傳成功",
    HOLIDAY_SUCCESSFULLY_DELETED:"假期已成功刪除",
    SB_MU_MB_2_2_0:" SB_MU_MB_2_2_0_Trans",
    SB_MU_MB_2_1_0:"SB_MU_MB_2_1_0_Trans",
    SB_MU_MB_2_0_0:"SB_MU_MB_2_0_0_Trans",
    SB_MU_2_2_0:"SB_MU_2_2_0_Trans",
    SB_MU_2_1_0:"SB_MU_2_1_0_Trans",
    SB_MU_2_0_0:"SB_MU_2_0_0_Trans",
    SB_MB_2_2_0:"SB_MB_2_2_0_Trans",
    SB_MB_2_1_0:"SB_MB_2_1_0_Trans",
    SB_MB_2_0_0:"SB_MB_2_0_0_Trans",
    SB_OB_2_2_0:"SB_OB_2_2_0_Trans",
    SB_OB_2_1_0:"SB_OB_2_1_0_Trans",
    SB_OB_2_0_0:"SB_OB_2_0_0_Trans",
    CB3_1_0_0:"CB3_1_0_0_Trans",
    CW35_3_0_0:"CW35_3_0_0_Trans",
    CW35_3_1_0:"CW35_3_1_0_Trans",
    CWB3_3_0_0:"CWB3_3_0_0_Trans",
    CWB3_3_1_0:"CWB3_3_1_0_Trans",
    CW1_3_0_0:"CW1_3_0_0_Trans",
    CW1_3_1_0:"CW1_3_1_0_Trans",
    CHEM_LEVEL_LOW_DRYING_AGENT:"乾燥劑填充量低",
    CHEM_LEVEL_LOW_SHAMPOO:"洗劑填充量低",
    CHEM_LEVEL_LOW_FOAM:"泡沫填充量低",
    CHEM_LEVEL_LOW_WAX_1:"蠟填充量低",
    CHEM_LEVEL_LOW_POLISH_1:"拋光填充量低",
    CHEM_LEVEL_LOW_RIM_CLEANER:"輪圈清潔劑填充量低",
    CHEM_LEVEL_LOW_WAX_2:"蠟填充量低",
    CHEM_LEVEL_LOW_TYRE_SHINE:"輪胎亮光蠟填充量低",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"除蟲劑填充量低",
    CHEM_LEVEL_LOW_POLISH_2:"拋光劑填充量低",
    CHEM_LEVEL_LOW_INTENSIVE:"intensive 填充量低",
    CHEM_LEVEL_LOW_FOAM_RAIN:"泡沫雨填充量低",
    CHEM_LEVEL_DRYING_AGENT:"乾燥劑填充量",
    CHEM_LEVEL_SHAMPOO:"洗劑填充量",
    CHEM_LEVEL_FOAM:"泡沫填充量",
    CHEM_LEVEL_WAX_1:"蠟填充量",
    CHEM_LEVEL_POLISH_1:"拋光劑填充量",
    CHEM_LEVEL_RIM_CLEANER:"輪圈清潔劑填充量",
    CHEM_LEVEL_WAX_2:"蠟填充量",
    CHEM_LEVEL_TYRE_SHINE:"輪胎亮光蠟填充量",
    CHEM_LEVEL_INSECT_REMOVER:"除蟲劑填充量",
    CHEM_LEVEL_POLISH_2:"拋光劑填充量",
    CHEM_LEVEL_INTENSIVE:"Intensive 填充量",
    CHEM_LEVEL_FOAM_RAIN:"泡沫雨填充量",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"服務台頂刷提升帶",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"服務台烘乾機提升帶",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"服務台馬達電纜屋頂刷",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"服務台淡水幫浦服務",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"服務台幫浦廢水",
    DRYING_AGENT:" 乾燥劑",
    FOAM_DRYING_AGENT:"泡沫乾洗劑",
    SHAMPOO:"洗劑",
    FOAM:"泡沫",
    BRUSH_FOAM:"毛刷泡沫",
    WAX_1:" 蠟",
    FOAM_WAX_1:"泡沫蠟",
    POLISH_1:" 拋光",
    RIM_CLEANING:" 輪圈亮光劑",
    WAX_2:" 蠟",
    FOAM_WAX_2:"泡沫蠟",
    TYRE_SHINE:"輪胎亮光蠟",
    INSECT_REMOVER:"除蟲劑",
    POLISH_2:" 拋光",
    INTENSIVE_BASIC:"Intensive 基礎",
    INTENSIVE_SIDE:"Intensive 側邊",
    INTENSIVE_ROOF_SPRAY_BAR:"Intensive 車頂噴桿",
    TAR_REMOVER:"柏油去除劑",
    UNDER_CHASSIS_CONVERSATION:"底盤對話",
    STATIONARY_PRE_SPRAY_ARCH:"固定式預噴拱",
    FOAM_RAIN:"泡沫雨",
    PRE_CLEANING:"預清洗",
    BRUSH:"毛刷",
    CARE:"照護",
    DRYING:"烘乾",
    DRYING_LOW_NOISE:"乾燥降低噪音",
    INTENSIVE_CLEANING:"Intensive 清洗",
    BRUSH_CLEANING:"毛刷清洗",
    EMPTY_RUN:"空轉",
    DRYING_AID:"乾燥輔助",
    WAX:"蠟",
    FOAM_WASH:" 泡沫清洗",
    POLISH:"拋光",
    FOAM_POLISH:"泡沫拋光劑",
    WHEEL_CLEANING:"車輪清潔",
    HIGH_PRESSURE_ROOF:" 車頂高壓",
    HIGH_PRESSURE_SIDE:"側邊高壓",
    DRYER_FORWARD:"烘乾機前進",
    DRYER_BACKWARD:" 烘乾機退後",
    DELETE_ALL_HOLIDAYS:"刪除所選網站的所有假期",
    CREATE_NEW_HOLIDAY:"創建新的",
    RESET_INPUTS:"重置所有假期輸入",
    TWENTY_FOUR_HOURS_OPEN:" 24小時營業",
    EVERY_YEAR:"每年",
    DELETE_HOLIDAY:" 刪除假期",
    ADD_NEW_HOLIDAY:"新增假期",
    HOLIDAYS_LIST:"現有假期列表",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"刪除所選場址的所有假期？",
    VALIDATION_HOLIDAY_DATE:"格式錯誤。使用 mm-dd",
    FOR_DATE:"對於日期",
    WITH_ID:"附上 ID",
    FROM_HOURS:"從(小時)",
    FROM_MINUTES:"從(分鐘)",
    TO_HOURS:"到(小時)",
    TO_MINUTES:"到(分鐘)",
    NOT_MATCH:"不匹配",
    START:"從",
    STOP:"到",
    DAILY_TIME:"24小時清單",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"個人時間設定",
    PROGRAM_NOT_STARTED:"程序尚未開始",
    JETWASH:"自助洗系統",
    KARCHER_REPORT_1:"龍門：依照程序以及總和的營業額指示",
    KARCHER_REPORT_2:"龍門：依照程序以及總和啟動的清洗",
    KARCHER_REPORT_3:"龍門：依照程序以及總和執行的清洗",
    KARCHER_REPORT_4:"龍門：依照每個程序透過支付終端以及總和開始的洗滌次數",
    KARCHER_REPORT_5:"龍門：依照程序以及總和手動啟動的清洗次數",
    KARCHER_REPORT_6:"龍門：依照程序以及總和的取消清洗次數",
    KARCHER_REPORT_7:"龍門：電源供應失敗次數",
    KARCHER_REPORT_8:"SB 單元：按車格篩選以及總計的每個洗滌程序的小時數",
    KARCHER_REPORT_9:"SB 單元：每個清洗區的營業額和總營業額指示",
    KARCHER_REPORT_10:"SB 單元：每個硬幣通道的代幣/硬幣計數器",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"淡水幫浦",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"製程用水幫浦",
    OPERATION_COUNTER_HP_PUMP_1:"高壓幫浦1",
    OPERATION_COUNTER_HP_PUMP_2:"高壓幫浦2",
    RELEASE_NOTES:"應用程式版本和發行說明",
    BACKEND_RELEASE_NOTES:"平台發行說明：",
    FRONTEND_RELEASE_NOTES:"Web 應用程式發行說明：",
    SELECTED_FACILITY_TIMEZONE:"所選設施的時區：",
    REFRESH_PAGE:"重新整理頁面",
    REFRESH_MAPS:"重新整理地圖",
    PUMPS:"幫浦",
    RUN_TIME:"運轉",
    RUN_TIME1:"運轉時間1",
    RUN_TIME2:"運轉時間2",
    PROGRAM_RUNTIME_ACTUATOR:"運轉時間執行器",
    PROGRAM_RUNTIME_ACTUATOR_1:"運轉時間執行器1",
    PROGRAM_RUNTIME_ACTUATOR_2:"運轉時間執行器2",
    PUMP_RUN_TIME_MIN_VALIDATION:"最小值為 1",
    PUMP_RUN_TIME_MAX_VALIDATION:"最大值為 255",
    WASH_PROGRAM_MIN_MAX_VALIDATION:"使用價格格式 x.xx",
    ACTUATION_NOT_ALLOWED:"目前使用者身分不允許啟動",
    MAINTENANCE_DAYS:" 保養天數",
    MAINTENANCE_WASHES:"保養清洗",
    DAILY_FINANCES_POS:"銷售點",
    POS_INCOME:"銷售點總收入",
    PROPAGATE:"宣傳",
    ALL_DAY_HOURS_SELECTOR:"24 小時類型選擇器",
    GET_OPERATING_TIME_FROM_SITE:"從站點工作時間表取得目前裝置的運行時間",
    USER_NOT_VALID:"用戶無效，嘗試使用其他帳戶憑證。",
    VERIFIED:"已驗證",
    RESEND_VERIFICATION_MAIL:"重新發送驗證郵件",
    RETURN_TO_DASHBOARD:" 返回儀表板",
    ERROR_PAGE_BAD_REQUEST:"400 錯誤請求",
    WASHES:"清洗次數",
    TIME_TO_SERVICE:" 服務時間",
    ACCOUNT_ALREADY_ACTIVATED:"已啟動帳戶",
    DEVICE_EVENTS:"Device events",
    DEVICE_EVENTS_LOG_PULLED:"Pulled event log for device ",
    EVENTS_PULL_DATE:"Pulled events time: ",
    DEVICE_EVENTS_REFRESH:"Pull new event data",
    WEB_SOCKETS_CONNECTION_PROBLEM:"Web sockets connection problem. Try to refresh page.",
    INSTALLATION_DATE:"Installation date of machine",
    KARCHER_CUSTOM_PROGRAM_NAME_1:"Hot wax",
    KARCHER_CUSTOM_PROGRAM_NAME_2:"High pressure washing",
    KARCHER_CUSTOM_PROGRAM_NAME_3:"Power rim foam",
    KARCHER_CUSTOM_PROGRAM_NAME_4:"Power foam",
    KARCHER_CUSTOM_PROGRAM_NAME_5:"Stop",
    KARCHER_CUSTOM_PROGRAM_NAME_6:"Foam wash HD",
    KARCHER_CUSTOM_PROGRAM_NAME_7:"Wash",
    KARCHER_CUSTOM_PROGRAM_NAME_8:"Top care",
    INFO_TITLE:"資訊",
    FOAM_WAX1:"泡沫洗車蠟",
    POLISH1:"拋光",
    WAX1:"蠟",
    SITE_DETAILS_SUCCESSFULLY_UPDATED:"場點詳情已成功更新",
    COMPANY:"公司",
    FACILITY_HAS_CHANGER:"有自動販售機嗎？",
    DISABLE_OFFLINE_ALARM:"停用R2W警報",
    ASIDE_WORKING_SCHEDULES:" App 網站詳情",
    TERMS_OF_SERVICE_R2W_TITLE:"Ready2Wash服務條款",
    TERMS_OF_SERVICE_R2W:"Ready2Wash服務條款",
    DATA_PROCESSING_TITLE:"資料已處理",
    PRIVACY_POLICY_TITLE:"隱私權政策",
    READY_TO_PAY_TERMS_OF_SERVICE:"Ready2Pay 服務條款",
    TERMS_AND_SERVICES:"條款與服務",
    HOURLY: "每小時",
    DAILY: "每日",
    WEEKLY: "每週",
    MONTHLY: "每月",
    YEARLY: "每年",
    DELETE_ITEM_SUCCESS:"您已成功刪除項目",
    STATE: "狀態",
    AVAILABILITY_STATUS_1: "單位開放",
    AVAILABILITY_STATUS_2: "單位關閉（假期）",
    AVAILABILITY_STATUS_3: "單位關閉（營業時間）",
    AVAILABILITY_STATUS_4: "單位關閉（故障）",
    AVAILABILITY_STATUS_5: "單位關閉（其他）",
    AVAILABILITY_VACUUMS_STATUS_1: "吸塵器未安裝",
    AVAILABILITY_VACUUMS_STATUS_2: "吸塵器開放",
    AVAILABILITY_VACUUMS_STATUS_3: "吸塵器關閉（假期）",
    AVAILABILITY_VACUUMS_STATUS_4: "吸塵器關閉（營業時間）",
    AVAILABILITY_VACUUMS_STATUS_5: "吸塵器關閉（故障）",
    AVAILABILITY_VACUUMS_STATUS_6: "吸塵器關閉（其他）",
    ECOM_AMOUNT: "所有地點的總 Ecom",
    CAPTURED: "已記錄",
    DELETE_COMPANY_HISTORY_INFO:"此操作將刪除您公司所有的報告數據。此操作無法撤銷。",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"您確定要永久刪除所有的報告數據嗎？",
    VALUE_DATE: "價值日期",
    KARCHER_EVENT_NAME_1: "主熱交換器已再生",
    KARCHER_EVENT_NAME_2: "主熱交換器再生完成",
    KARCHER_EVENT_NAME_3: "材料 / 序列號",
    KARCHER_EVENT_NAME_4: "系統已消毒",
    KARCHER_EVENT_NAME_5: "HP 泵 1 已消毒",
    KARCHER_EVENT_NAME_6: "HP 泵 2 已消毒",
    KARCHER_EVENT_NAME_7: "HP 泵 3 已消毒",
    KARCHER_EVENT_NAME_8: "HP 泵 4 已消毒",
    KARCHER_EVENT_NAME_9: "HP 泵 5 已消毒",
    KARCHER_EVENT_NAME_10: "洗車站 1 已鎖定",
    KARCHER_EVENT_NAME_11: "洗車站 2 已鎖定",
    KARCHER_EVENT_NAME_12: "洗車站 3 已鎖定",
    KARCHER_EVENT_NAME_13: "洗車站 4 已鎖定",
    KARCHER_EVENT_NAME_14: "洗車站 5 已鎖定",
    KARCHER_EVENT_NAME_15: "洗車站 6 已鎖定",
    KARCHER_EVENT_NAME_16: "洗車站 7 已鎖定",
    KARCHER_EVENT_NAME_17: "洗車站 8 已鎖定",
    KARCHER_EVENT_NAME_18: "更新已開始",
    KARCHER_EVENT_NAME_19: "更新完成",
    KARCHER_EVENT_NAME_20: "WS 註冊開始",
    KARCHER_EVENT_NAME_21: "WS 註冊結束",
    KARCHER_EVENT_NAME_22: "WS 感測器 75%",
    KARCHER_EVENT_NAME_23: "技術故障",
    KARCHER_EVENT_NAME_24: "操作故障",
    KARCHER_EVENT_NAME_25: "設備已啟動",
    KARCHER_EVENT_NAME_26: "設備已關閉",
    KARCHER_EVENT_NAME_27: "箱子 1 已關閉",
    KARCHER_EVENT_NAME_28: "箱子 2 已關閉",
    KARCHER_EVENT_NAME_29: "箱子 3 已關閉",
    KARCHER_EVENT_NAME_30: "箱子 4 已關閉",
    KARCHER_EVENT_NAME_31: "箱子 5 已關閉",
    KARCHER_EVENT_NAME_32: "箱子 6 已關閉",
    KARCHER_EVENT_NAME_33: "箱子 7 已關閉",
    KARCHER_EVENT_NAME_34: "箱子 8 已關閉",
    KARCHER_EVENT_NAME_35: "HP 泵站 1",
    KARCHER_EVENT_NAME_36: "HP 泵站 2",
    KARCHER_EVENT_NAME_37: "HP 泵站 3",
    KARCHER_EVENT_NAME_38: "HP 泵站 4",
    KARCHER_EVENT_NAME_39: "HP 泵站 5",
    KARCHER_EVENT_NAME_40: "HP 泵站 6",
    KARCHER_EVENT_NAME_41: "HP 泵站 7",
    KARCHER_EVENT_NAME_42: "HP 泵站 8",
    KARCHER_EVENT_NAME_43: "燃燒器",
    KARCHER_EVENT_NAME_44: "燃燒器風扇",
    KARCHER_EVENT_NAME_45: "熱水泵",
    KARCHER_EVENT_NAME_46: "防凍泵",
    KARCHER_EVENT_NAME_47: "滲透泵",
    KARCHER_EVENT_NAME_48: "地板加熱",
    KARCHER_EVENT_NAME_49: "管道加熱",
    KARCHER_EVENT_NAME_50: "微清洗 / 輪轂清洗",
    KARCHER_EVENT_NAME_51: "底盤清洗泵",
    KARCHER_EVENT_NAME_52: "泡沫增壓泵",
    KARCHER_EVENT_NAME_53: "吸塵機 1",
    KARCHER_EVENT_NAME_54: "吸塵機 2",
    KARCHER_EVENT_NAME_55: "吸塵機 3",
    KARCHER_EVENT_NAME_56: "吸塵機 4",
    KARCHER_EVENT_NAME_57: "吸塵機 5",
    KARCHER_EVENT_NAME_58: "吸塵機 6",
    KARCHER_EVENT_NAME_59: "吸塵機 7",
    KARCHER_EVENT_NAME_60: "吸塵機 8",
    KARCHER_EVENT_NAME_61: "吸塵機 9",
    KARCHER_EVENT_NAME_62: "吸塵機 10",
    KARCHER_EVENT_NAME_63: "吸塵機 11",
    KARCHER_EVENT_NAME_64: "吸塵機 12",
    KARCHER_EVENT_NAME_65: "輪轂清洗泵",
    KARCHER_EVENT_NAME_66: "微泵",
    KARCHER_EVENT_NAME_67: "高強度泵",
    KARCHER_EVENT_NAME_68: "吸塵機渦輪 1",
    KARCHER_EVENT_NAME_69: "吸塵機濾網 1",
    KARCHER_EVENT_NAME_70: "吸塵機渦輪 2",
    KARCHER_EVENT_NAME_71: "吸塵機濾網 2",
    KARCHER_EVENT_NAME_72: "吸塵機渦輪 3",
    KARCHER_EVENT_NAME_73: "吸塵機濾網 3",
    KARCHER_EVENT_NAME_74: "吸塵機渦輪 4",
    KARCHER_EVENT_NAME_75: "吸塵機濾網 4",
    KARCHER_EVENT_NAME_76: "吸塵機渦輪 5",
    KARCHER_EVENT_NAME_77: "吸塵機濾網 5",
    KARCHER_EVENT_NAME_78: "吸塵機渦輪 6",
    KARCHER_EVENT_NAME_79: "吸塵機濾網 6",
    KARCHER_EVENT_NAME_80: "吸塵機渦輪 7",
    KARCHER_EVENT_NAME_81: "吸塵機濾網 7",
    KARCHER_EVENT_NAME_82: "吸塵機渦輪 8",
    KARCHER_EVENT_NAME_83: "吸塵機濾網 8",
    KARCHER_EVENT_NAME_84: "吸塵機渦輪 9",
    KARCHER_EVENT_NAME_85: "吸塵機濾網 9",
    KARCHER_EVENT_NAME_86: "吸塵機渦輪 10",
    KARCHER_EVENT_NAME_87: "吸塵機濾網 10",
    KARCHER_EVENT_NAME_88: "吸塵機渦輪 11",
    KARCHER_EVENT_NAME_89: "吸塵機濾網 11",
    KARCHER_EVENT_NAME_90: "吸塵機渦輪 12",
    KARCHER_EVENT_NAME_91: "吸塵機濾網 12",
    INSERT_TOKEN: "輸入憑證代碼並啟動服務",
    OPEN_SESSION: "會話已成功開啟",
    IN_PROGRESS: "進行中...",
    TOKEN_INSERTED: "憑證代碼已成功輸入",
    EXPIRED_SESSION: "會話已過期",
    TWO_DIGIT_INTEGER_VALIDATION: "請輸入最多兩位數的整數",
    KARCHER_OPERATION_COUNTER_1: "洗車站 1 高壓泵",
    KARCHER_OPERATION_COUNTER_2: "洗車站 1 化學泵 1",
    KARCHER_OPERATION_COUNTER_3: "洗車站 1 化學泵 2",
    KARCHER_OPERATION_COUNTER_4: "洗車站 1 化學泵 3",
    KARCHER_OPERATION_COUNTER_5: "洗車站 1 化學泵 4",
    KARCHER_OPERATION_COUNTER_6: "洗車站 2 高壓泵",
    KARCHER_OPERATION_COUNTER_7: "洗車站 2 化學泵 1",
    KARCHER_OPERATION_COUNTER_8: "洗車站 2 化學泵 2",
    KARCHER_OPERATION_COUNTER_9: "洗車站 2 化學泵 3",
    KARCHER_OPERATION_COUNTER_10: "洗車站 2 化學泵 4",
    KARCHER_OPERATION_COUNTER_11: "洗車站 3 高壓泵",
    KARCHER_OPERATION_COUNTER_12: "洗車站 3 化學泵 1",
    KARCHER_OPERATION_COUNTER_13: "洗車站 3 化學泵 2",
    KARCHER_OPERATION_COUNTER_14: "洗車站 3 化學泵 3",
    KARCHER_OPERATION_COUNTER_15: "洗車站 3 化學泵 4",
    KARCHER_OPERATION_COUNTER_16: "洗車站 4 高壓泵",
    KARCHER_OPERATION_COUNTER_17: "洗車站 4 化學泵 1",
    KARCHER_OPERATION_COUNTER_18: "洗車站 4 化學泵 2",
    KARCHER_OPERATION_COUNTER_19: "洗車站 4 化學泵 3",
    KARCHER_OPERATION_COUNTER_20: "洗車站 4 化學泵 4",
    KARCHER_OPERATION_COUNTER_21: "洗車站 5 高壓泵",
    KARCHER_OPERATION_COUNTER_22: "洗車站 5 化學泵 1",
    KARCHER_OPERATION_COUNTER_23: "洗車站 5 化學泵 2",
    KARCHER_OPERATION_COUNTER_24: "洗車站 5 化學泵 3",
    KARCHER_OPERATION_COUNTER_25: "洗車站 5 化學泵 4",
    KARCHER_OPERATION_COUNTER_26: "洗車站 6 高壓泵",
    KARCHER_OPERATION_COUNTER_27: "洗車站 6 化學泵 1",
    KARCHER_OPERATION_COUNTER_28: "洗車站 6 化學泵 2",
    KARCHER_OPERATION_COUNTER_29: "洗車站 6 化學泵 3",
    KARCHER_OPERATION_COUNTER_30: "洗車站 6 化學泵 4",
    KARCHER_OPERATION_COUNTER_31: "洗車站 7 高壓泵",
    KARCHER_OPERATION_COUNTER_32: "洗車站 7 化學泵 1",
    KARCHER_OPERATION_COUNTER_33: "洗車站 7 化學泵 2",
    KARCHER_OPERATION_COUNTER_34: "洗車站 7 化學泵 3",
    KARCHER_OPERATION_COUNTER_35: "洗車站 7 化學泵 4",
    KARCHER_OPERATION_COUNTER_36: "洗車站 8 高壓泵",
    KARCHER_OPERATION_COUNTER_37: "洗車站 8 化學泵 1",
    KARCHER_OPERATION_COUNTER_38: "洗車站 8 化學泵 2",
    KARCHER_OPERATION_COUNTER_39: "洗車站 8 化學泵 3",
    KARCHER_OPERATION_COUNTER_40: "洗車站 8 化學泵 4",
    KARCHER_OPERATION_COUNTER_41: "滲透泵",
    KARCHER_OPERATION_COUNTER_42: "熱水發生器",
    KARCHER_OPERATION_COUNTER_43: "防凍泵",
    KARCHER_OPERATION_COUNTER_44: "WSO過濾器濾芯",
    KARCHER_OPERATION_COUNTER_45: "洗車站加熱泵",
    KARCHER_OPERATION_COUNTER_46: "熱水泵",
    KARCHER_OPERATION_COUNTER_47: "泡沫管加熱器",
    KARCHER_OPERATION_COUNTER_48: "輪胎清洗泵",
    KARCHER_OPERATION_COUNTER_49: "微乳化泵",
    KARCHER_OPERATION_COUNTER_50: "高效泡沫泵",
    KARCHER_OPERATION_COUNTER_51: "吸塵器 1 渦輪 1",
    KARCHER_OPERATION_COUNTER_52: "吸塵器 1 過濾器 1",
    KARCHER_OPERATION_COUNTER_53: "吸塵器 1 渦輪 2",
    KARCHER_OPERATION_COUNTER_54: "吸塵器 1 過濾器 2",
    KARCHER_OPERATION_COUNTER_55: "吸塵器 2 渦輪 1",
    KARCHER_OPERATION_COUNTER_56: "吸塵器 2 過濾器 1",
    KARCHER_OPERATION_COUNTER_57: "吸塵器 2 渦輪 2",
    KARCHER_OPERATION_COUNTER_58: "吸塵器 2 過濾器 2",
    KARCHER_OPERATION_COUNTER_59: "吸塵器 3 渦輪 1",
    KARCHER_OPERATION_COUNTER_60: "吸塵器 3 過濾器 1",
    KARCHER_OPERATION_COUNTER_61: "吸塵器 3 渦輪 2",
    KARCHER_OPERATION_COUNTER_62: "吸塵器 3 過濾器 2",
    KARCHER_OPERATION_COUNTER_63: "吸塵器 4 渦輪 1",
    KARCHER_OPERATION_COUNTER_64: "吸塵器 4 過濾器 1",
    KARCHER_OPERATION_COUNTER_65: "吸塵器 4 渦輪 2",
    KARCHER_OPERATION_COUNTER_66: "吸塵器 4 過濾器 2",
    KARCHER_OPERATION_COUNTER_67: "吸塵器 5 渦輪 1",
    KARCHER_OPERATION_COUNTER_68: "吸塵器 5 過濾器 1",
    KARCHER_OPERATION_COUNTER_69: "吸塵器 5 渦輪 2",
    KARCHER_OPERATION_COUNTER_70: "吸塵器 5 過濾器 2",
    KARCHER_OPERATION_COUNTER_71: "吸塵器 6 渦輪 1",
    KARCHER_OPERATION_COUNTER_72: "吸塵器 6 過濾器 1",
    KARCHER_OPERATION_COUNTER_73: "吸塵器 6 渦輪 2",
    KARCHER_OPERATION_COUNTER_74: "吸塵器 6 過濾器 2",
    KARCHER_OPERATION_COUNTER_75: "清除壓縮機中的冷凝水",
    KARCHER_OPERATION_COUNTER_76: "檢查防凍系統",
    KARCHER_OPERATION_COUNTER_77: "燃燒器風扇",
    KARCHER_OPERATION_COUNTER_78: "增壓泡沫泵",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "數據列表超過 10000 項",
    KARCHER_POINT_NAME_1: "假日",
    KARCHER_POINT_NAME_2: "星期一",
    KARCHER_POINT_NAME_3: "星期二",
    KARCHER_POINT_NAME_4: "星期三",
    KARCHER_POINT_NAME_5: "星期四",
    KARCHER_POINT_NAME_6: "星期五",
    KARCHER_POINT_NAME_7: "星期六",
    KARCHER_POINT_NAME_8: "星期日",
    KARCHER_POINT_NAME_9: "吸塵器 假日",
    KARCHER_POINT_NAME_10: "吸塵器 星期一",
    KARCHER_POINT_NAME_11: "吸塵器 星期二",
    KARCHER_POINT_NAME_12: "吸塵器 星期三",
    KARCHER_POINT_NAME_13: "吸塵器 星期四",
    KARCHER_POINT_NAME_14: "吸塵器 星期五",
    KARCHER_POINT_NAME_15: "吸塵器 星期六",
    KARCHER_POINT_NAME_16: "吸塵器 星期日",
    KARCHER_POINT_NAME_17: "照明 假日",
    KARCHER_POINT_NAME_18: "照明 星期一",
    KARCHER_POINT_NAME_19: "照明 星期二",
    KARCHER_POINT_NAME_20: "照明 星期三",
    KARCHER_POINT_NAME_21: "照明 星期四",
    KARCHER_POINT_NAME_22: "照明 星期五",
    KARCHER_POINT_NAME_23: "照明 星期六",
    KARCHER_POINT_NAME_24: "照明 星期日",
    KARCHER_POINT_NAME_25: "程式 0",
    KARCHER_POINT_NAME_26: "程式 1",
    KARCHER_POINT_NAME_27: "程式 2",
    KARCHER_POINT_NAME_28: "程式 3",
    KARCHER_POINT_NAME_29: "程式 4",
    KARCHER_POINT_NAME_30: "程式 5",
    KARCHER_POINT_NAME_31: "程式 6",
    KARCHER_POINT_NAME_32: "程式 7",
    KARCHER_POINT_NAME_33: "程式 8",
    KARCHER_POINT_NAME_34: "程式 9",
    KARCHER_POINT_NAME_35: "程式 10",
    KARCHER_POINT_NAME_36: "程式 11",
    KARCHER_POINT_NAME_37: "程式 12",
    KARCHER_POINT_NAME_38: "程式 13",
    KARCHER_POINT_NAME_39: "程式 14",
    KARCHER_POINT_NAME_40: "程式 15",
    KARCHER_POINT_NAME_41: "程式 16",
    KARCHER_POINT_NAME_42: "程式 17",
    KARCHER_POINT_NAME_43: "程式 18",
    KARCHER_POINT_NAME_44: "程式 19",
    KARCHER_POINT_NAME_45: "程式 20",
    KARCHER_POINT_NAME_46: "程式 21",
    KARCHER_POINT_NAME_47: "程式 22",
    KARCHER_POINT_NAME_48: "程式 23",
    KARCHER_POINT_NAME_49: "程式 24",
    KARCHER_POINT_NAME_50: "程式 25",
    KARCHER_POINT_NAME_51: "程式 26",
    KARCHER_POINT_NAME_52: "程式 27",
    KARCHER_POINT_NAME_53: "程式 28",
    KARCHER_POINT_NAME_54: "程式 29",
    KARCHER_POINT_NAME_55: "程式 30",
    KARCHER_POINT_NAME_56: "程式 31",
    KARCHER_POINT_NAME_57: "程式 32",
    QR_CODE: "QR 碼",
    ACCEPT_TERMS_AND_CONDITIONS: "接受條款和條件",
    CREATE_AND_PRINT_VOUCHERS: "建立和列印優惠券",
    CODE_PREFIX_QUESTION: "未輸入代碼字首",
    CODE_PREFIX_QUESTION_TEXT: "您想繼續而不使用代碼前綴嗎？",
    ISSUED_DATE: "發行日期",
    VOUCHER_VALIDITY_DAYS: "優惠券有效期（天）",
    IDENTIFICATION_CODE: "識別碼",
    VALIDATION_ONLY_NUMBERS: "僅允許數字",
    REPRINT_VOUCHERS: "列印優惠券副本",
    EXPIRY_DATE: "有效期至",
    VOUCHER_TYPE_VACUUM: "優惠券: 吸塵器",
    VOUCHER_TYPE_JETWASH: "優惠券: Jet Wash Care",
    VOUCHER_TYPE_MATT: "優惠券: Matt"
  });
})();
